{
  "common": {
    "loading": "Загрузка...",
    "error": "Произошла ошибка",
    "save": "Сохранить",
    "cancel": "Отмена",
    "confirm": "Подтвердить",
    "back": "Назад",
    "next": "Далее",
    "submit": "Отправить",
    "search": "Поиск",
    "filter": "Фильтр",
    "export": "Экспорт",
    "delete": "Удалить",
    "edit": "Редактировать",
    "view": "Просмотр",
    "close": "Закрыть",
    "yes": "Да",
    "no": "Нет",
    "skip": "Пропустить",
    "continue": "Продолжить",
    "print": "Печать",
    "download": "Скачать",
    "language": "Язык",
    "saving": "Сохранение...",
    "previous": "Предыдущий",
    "retry": "Повторить",
    "clear": "Очистить",
    "actions": "Действия",
    "showing": "Показано",
    "of": "из",
    "noData": "Нет данных",
    "required": "Обязательно",
    "optional": "Необязательно",
    "active": "Активно",
    "inactive": "Неактивно",
    "viewAll": "Показать все",
    "apply": "Применить",
    "deleting": "Удаление...",
    "saved": "Сохранено",
    "add": "Добавить",
    "remove": "Удалить",
    "dismiss": "Закрыть"
  },
  "nav": {
    "dashboard": "Панель управления",
    "patients": "Пациенты",
    "assessments": "Обследования",
    "reports": "Отчёты",
    "settings": "Настройки",
    "help": "Помощь",
    "analytics": "Аналитика",
    "clinicSettings": "Настройки клиники",
    "auditLog": "Журнал аудита",
    "gdpr": "GDPR / Данные",
    "editProfile": "Редактирование Профиля",
    "myProfile": "Мой Профиль",
    "noTitle": "(нет)",
    "title": "Звание",
    "frontdesk": "Регистратура",
    "exercises": "Упражнения",
    "conditions": "Состояния",
    "superadmin": "SuperAdmin",
    "kpi": "Портал KPI",
    "referralGaps": "Пробелы в источниках направления",
    "staffBoard": "Доска команды"
  },
  "auth": {
    "signIn": "Войти",
    "signOut": "Выйти",
    "email": "Email",
    "password": "Пароль",
    "forgotPassword": "Забыли пароль?",
    "emailPasswordRequired": "Введите email и пароль",
    "appTitle": "MSK Insight",
    "appSubtitle": "Платформа клинической поддержки решений",
    "signInSubtitle": "Войдите в свой аккаунт",
    "emailLabel": "Адрес электронной почты",
    "emailPlaceholder": "you@clinic.com",
    "passwordPlaceholder": "Введите пароль",
    "signingIn": "Вход…",
    "loginFailed": "Ошибка входа",
    "footer": "Доказательная помощь при заболеваниях опорно-двигательного аппарата · Соответствие GDPR"
  },
  "dashboard": {
    "greeting": {
      "morning": "Доброе утро",
      "afternoon": "Добрый день",
      "evening": "Добрый вечер"
    },
    "newPatient": "Новый пациент",
    "newAssessment": "Новое обследование",
    "viewAllPatients": "Все пациенты",
    "totalPatients": "Всего пациентов",
    "thisMonth": "В этом месяце",
    "assessments": "обследования",
    "pendingReviews": "Ожидают проверки",
    "activeCare": "Активное лечение",
    "allTime": "За всё время",
    "avgWellness": "Средний балл",
    "completion": "Завершение",
    "assessmentsPerMonth": "Обследования по месяцам",
    "noDataYet": "Данных пока нет",
    "topConditions": "Частые диагнозы",
    "noDiagnoses": "Диагнозов пока нет",
    "bodyRegionDistribution": "Распределение по областям тела",
    "noRegionData": "Данных по областям пока нет",
    "fullAnalytics": "Полная аналитика",
    "needsCompletion": "Требует завершения",
    "allCaughtUp": "Всё готово! Нет обследований, ожидающих завершения.",
    "saved": "Сохранено ",
    "awaitingFrontDesk": "Ожидает регистратуру",
    "frontDeskWorking": "Регистратура работает",
    "inProgress": "В процессе",
    "complete": "Завершено",
    "recentPatients": "Недавние пациенты",
    "recentAssessments": "Недавние обследования",
    "noPatients": "Пациентов пока нет",
    "addFirstPatientMsg": "Добавьте первого пациента, чтобы начать.",
    "addFirstPatient": "Добавить первого пациента",
    "noVisits": "Нет визитов",
    "table": {
      "patient": "Пациент",
      "age": "Возраст",
      "carePhase": "Фаза лечения",
      "lastVisit": "Последний визит",
      "clinician": "Клиницист",
      "status": "Статус",
      "date": "Дата"
    },
    "stable": "стабильно",
    "onTrack": "в норме",
    "last6Months": "Последние 6 месяцев"
  },
  "patient": {
    "new": "Новый пациент",
    "search": "Поиск пациентов",
    "firstName": "Имя",
    "lastName": "Фамилия",
    "dateOfBirth": "Дата рождения",
    "phone": "Телефон",
    "email": "Email",
    "carePhase": "Фаза лечения"
  },
  "patients": {
    "title": "Пациенты",
    "newPatient": "+ Новый пациент",
    "searchPlaceholder": "Поиск по имени, MRN, телефону...",
    "allPhases": "Все фазы",
    "initial": "Начальная",
    "activeCare": "Активное лечение",
    "maintenance": "Поддерживающая",
    "wellness": "Оздоровление",
    "noFound": "Пациенты не найдены",
    "table": {
      "name": "Имя",
      "mrn": "MRN",
      "dob": "Дата рождения",
      "phone": "Телефон",
      "carePhase": "Фаза лечения",
      "lastUpdated": "Обновлено"
    },
    "guardian": "Опекун",
    "total": "пациентов",
    "firstName": "Имя",
    "lastName": "Фамилия",
    "status": {
      "active": "Активный",
      "doNotContact": "Не связываться"
    },
    "typeahead": {
      "loading": "Поиск…",
      "empty": "Пациенты не найдены",
      "error": "Поиск сейчас недоступен",
      "lastSeen": "Последний",
      "nextSeen": "Следующий",
      "lastAppt": "Посл. приём:",
      "nextAppt": "След. приём:"
    },
    "loadError": {
      "title": "Не удалось загрузить пациентов.",
      "body": "Что-то пошло не так на нашей стороне. Пожалуйста, повторите попытку через минуту.",
      "unavailable": "Данные пациентов временно недоступны. Пожалуйста, повторите попытку позже.",
      "retry": "Повторить"
    }
  },
  "patientDetail": {
    "backToPatients": "К списку пациентов",
    "startAssessment": "Начать обследование",
    "patientInfo": "Информация о пациенте",
    "dateOfBirth": "Дата рождения",
    "gender": "Пол",
    "phone": "Телефон",
    "email": "Email",
    "language": "Язык",
    "carePhase": "Фаза лечения",
    "registered": "Зарегистрирован",
    "assessments": "Обследования",
    "noAssessments": "Обследований пока нет. Нажмите \"Начать обследование\" для начала.",
    "continueAssessment": "Продолжить обследование",
    "notFound": "Пациент не найден",
    "step": "Шаг",
    "reexam": {
      "title": "Найдено предыдущее обследование",
      "message": "У пациента есть предыдущее обследование от {{date}}. Что вы хотите:",
      "startReexam": "Начать повторное обследование",
      "reexamDesc": "Сравнение с предыдущим обследованием. Существующие жалобы загружены. Можно добавить новые.",
      "startNew": "Новое обследование",
      "newDesc": "Новое полное обследование — другая причина визита или новая клиническая картина."
    },
    "deleteModal": {
      "title": "Удаление пациента",
      "message": "Вы уверены, что хотите навсегда удалить {{name}} и все обследования? Это действие необратимо.",
      "typeToConfirm": "Введите фамилию пациента ({{lastName}}) для подтверждения:",
      "deleting": "Удаление..."
    },
    "needsRepair": {
      "title": "Эта карта пациента требует восстановления",
      "body": "Часть этой карты сейчас не читается. Проблема зарегистрирована, ничего не изменено. Не создавайте пациента заново — обратитесь в поддержку, если эта карта нужна вам сегодня."
    },
    "loadFailed": "Не удалось загрузить этого пациента."
  },
  "patientForm": {
    "editTitle": "Редактирование пациента",
    "newTitle": "Новый пациент",
    "firstNameLabel": "Имя *",
    "lastNameLabel": "Фамилия *",
    "dateOfBirthLabel": "Дата рождения *",
    "genderLabel": "Пол",
    "selectGender": "Выберите...",
    "male": "Мужской",
    "female": "Женский",
    "other": "Другой",
    "phoneLabel": "Телефон",
    "emailLabel": "Email",
    "languageLabel": "Язык",
    "english": "Английский",
    "greek": "Греческий",
    "russian": "Русский",
    "hebrew": "Иврит",
    "carePhaseLabel": "Фаза лечения",
    "initial": "Начальная",
    "activeCare": "Активное лечение",
    "maintenance": "Поддерживающая",
    "wellness": "Оздоровление",
    "saving": "Сохранение...",
    "updatePatient": "Обновить пациента",
    "createPatient": "Создать пациента",
    "guardianLabel": "Опекун / Родитель",
    "relationshipLabel": "Отношение к пациенту",
    "selectRelationship": "Выберите отношение",
    "mother": "Мать",
    "father": "Отец",
    "legalGuardian": "Законный опекун",
    "carer": "Попечитель",
    "minorWarning": "Пациенту менее 18 лет ({{age}} {{unit}}) — Требуется информация об опекуне",
    "guardianNamePlaceholder": "напр. Иванова Мария",
    "dayPlaceholder": "ДД",
    "monthPlaceholder": "ММ",
    "yearPlaceholder": "ГГГГ",
    "errors": {
      "required": "Имя, фамилия и дата рождения обязательны",
      "saveFailed": "Ошибка сохранения пациента",
      "guardianRequired": "Имя опекуна / родителя обязательно для пациентов младше 18 лет",
      "genderRequired": "Пол обязателен"
    },
    "contactInfo": "Контактная информация",
    "editDescription": "Обновите данные пациента",
    "newDescription": "Заполните данные для регистрации нового пациента",
    "personalInfo": "Личные данные",
    "preferences": "Предпочтения"
  },
  "aiPaste": {
    "analyze": "Анализ с помощью AI",
    "analyzing": "Анализируется...",
    "aiTruncated": "Анализ ИИ не завершился — ответ ИИ превысил доступный лимит. Автоматическая повторная попытка уже выполнена. Попробуйте ещё раз; при очень длинном анамнезе поможет вставка меньшего фрагмента. Либо воспользуйтесь пошаговой анкетой.",
    "examSkippedTitle": "{{count}} результатов осмотра не удалось сохранить, и они НЕ были записаны:",
    "examSkippedUnknownKey": "этого теста нет в каталоге тестов",
    "examSkippedInvalidResult": "значение результата не распознано",
    "examSkippedHelp": "Всё остальное сохранено. Внесите их на шаге осмотра, если это реальные находки.",
    "removedTitle": "{{count}} предложенных жалоб удалено проверкой достоверности:",
    "removedExamDerived": "Удалено: получено из данных осмотра",
    "removedNoEvidence": "Удалено: нет дословного подтверждения в записях",
    "strippedNegatives": "Некоторые утверждения «нет ...» не имели подтверждения в ваших записях и были удалены. Аллергии без указанного статуса отображаются как не зафиксированные.",
    "deadline": "Анализ ИИ занял слишком много времени и был остановлен через 150 секунд. Ничего из этой попытки не сохранено. Попробуйте ещё раз или перейдите к пошаговому опроснику.",
    "retry": "Повторить",
    "clientTimeout": "Анализ ИИ не ответил вовремя и был остановлен. Ничего из этой попытки не применено. Попробуйте ещё раз или перейдите к пошаговому опроснику."
  },
  "holistic": {
    "invalid": "Клинический анализ ИИ не завершился — ответ ИИ был неполным или некорректным. Автоматическая повторная попытка уже выполнена. Пожалуйста, попробуйте ещё раз.",
    "longWait": "Всё ещё выполняется — ИИ, возможно, делает вторую попытку. Это может занять до двух минут.",
    "takes": "Обычно это занимает меньше минуты",
    "retry": "Попробовать снова",
    "notGenerated": "Клинический анализ ИИ для этой оценки не создан.",
    "notGeneratedInvalid": "Сохранённый анализ ИИ был неполным и отложен. Создайте его заново, когда будете готовы.",
    "regenerate": "Создать анализ",
    "saveFailed": "Не удалось сохранить целостный анализ. Ваши правки не сохранены — попробуйте ещё раз."
  },
  "aiCaller": {
    "soapInvalid": "SOAP-заметка ИИ не завершилась — ответ ИИ был неполным или некорректным. Автоматическая повторная попытка уже выполнена. Пожалуйста, попробуйте ещё раз.",
    "summaryInvalid": "Сводка ИИ не завершилась — ответ ИИ был неполным или некорректным. Автоматическая повторная попытка уже выполнена. Пожалуйста, попробуйте ещё раз.",
    "secondOpinionInvalid": "Второе мнение ИИ не завершилось — ответ ИИ был неполным или некорректным. Автоматическая повторная попытка уже выполнена. Пожалуйста, попробуйте ещё раз.",
    "letterInvalid": "Письмо ИИ не завершилось — ответ ИИ был неполным или некорректным. Автоматическая повторная попытка уже выполнена. Пожалуйста, попробуйте ещё раз.",
    "retry": "Попробовать снова",
    "translationInvalid": "Перевод отчёта не завершился — ответ ИИ был неполным, некорректным или не на целевом языке. Автоматическая повторная попытка уже выполнена. Пожалуйста, попробуйте ещё раз.",
    "uploadTextInvalid": "Сводка загруженного файла не завершилась — ответ ИИ был неполным. Автоматическая повторная попытка уже выполнена. Пожалуйста, попробуйте ещё раз.",
    "postureExtractInvalid": "Извлечение PostureScreen не завершилось — ответ ИИ был неполным или некорректным. Автоматическая повторная попытка уже выполнена. Пожалуйста, попробуйте ещё раз."
  },
  "assessment": {
    "new": "Новое обследование",
    "resume": "Продолжить",
    "complete": "Завершено",
    "draft": "Черновик",
    "fullAssessment": "Полное обследование",
    "quickScore": "Быстрая оценка",
    "reExam": "Повторное обследование",
    "steps": {
      "medicalHistory": "Анамнез",
      "chiefComplaints": "Основные жалобы",
      "physicalExamination": "Физический осмотр",
      "postureAnalysis": "Анализ осанки",
      "investigations": "Исследования",
      "outcomeMeasures": "Показатели исхода",
      "ddxReview": "Обзор ДДх",
      "managementPlan": "План лечения",
      "reportGeneration": "Создание отчёта"
    },
    "readOnly": "Это обследование завершено и доступно только для чтения.",
    "completedBy": "Эти шаги выполнены {{name}}. Свяжитесь с ними для изменений.",
    "completedByClinician": "Эти шаги выполнены клиницистом. Свяжитесь с ним для изменений.",
    "bodyMap": {
      "instruction": "Нажмите на области тела, где у пациента есть боль или симптомы. Выберите до 5 областей.",
      "noRegions": "Области не выбраны",
      "regionsSelected": "{{count}} область(-ей) выбрано",
      "startDetail": "Начать описание жалобы",
      "editRegions": "Изменить области",
      "regions": "Области: "
    },
    "redFlags": {
      "title": "Обнаружены красные флаги",
      "requireAction": "Следующие красные флаги требуют действий клинициста.",
      "clear": "Проверка красных флагов завершена. Не выявлено проблем, требующих немедленных действий.",
      "instruction": "Ответьте ДА или НЕТ на каждый вопрос проверки. Они задаются один раз для всего обследования.",
      "backToComplaints": "Назад к жалобам",
      "submitting": "Отправка...",
      "submitAndContinue": "Отправить проверку и продолжить"
    },
    "saveAsDraft": "Сохранить как черновик — регистратура завершит",
    "continueToReport": "Перейти к созданию отчёта",
    "finalize": {
      "instruction": "Когда все разделы готовы, завершите отчёт.",
      "button": "Завершить отчёт",
      "success": "Отчёт завершён и готов для пациента. Перенаправление на панель управления…"
    },
    "stepComingSoon": "Шаг {{step}} — скоро будет доступен.",
    "loadingAssessment": "Загрузка обследования…",
    "goBack": "Вернуться",
    "noPatient": "Пациент не выбран. Начните обследование из профиля пациента.",
    "viewPatients": "Просмотр пациентов",
    "finalized": "Завершено",
    "navigation": {
      "previousSection": "Предыдущий раздел",
      "continueTo": "Перейти к {{step}}",
      "nextSection": "Следующий раздел",
      "completeAssessment": "Завершить обследование",
      "saveAndContinueTo": "Сохранить и перейти к {{step}}"
    }
  },
  "clinical": {
    "findings": "Клинические данные",
    "observations": "Наблюдения",
    "workingHypothesis": "Рабочая гипотеза",
    "assessment": "Обследование",
    "aiSuggested": "Предложение ИИ — ожидает подтверждения клинициста",
    "confirmedBy": "Подтверждено клиницистом",
    "redFlag": "Красный флаг — требуется немедленное внимание"
  },
  "medicalHistory": {
    "title": "Анамнез",
    "pastMedical": "Предыдущие заболевания",
    "currentMedications": "Текущие лекарства",
    "allergies": "Аллергии",
    "lifestyle": "Оценка Образа Жизни",
    "familyHistory": "Семейный анамнез",
    "socialHistory": "Социальный анамнез",
    "surgicalHistory": "Хирургический анамнез",
    "reviewOfSystems": "Обзор систем",
    "noConditions": "Заболевания не указаны",
    "noMedications": "Нет текущих лекарств",
    "noAllergies": "Известных аллергий нет",
    "addCondition": "Добавить заболевание",
    "addMedication": "Добавить лекарство",
    "addAllergy": "Добавить аллергию",
    "condition": "Заболевание",
    "medication": "Лекарство",
    "dosage": "Дозировка",
    "frequency": "Частота",
    "allergen": "Аллерген",
    "reaction": "Реакция",
    "severity": "Тяжесть",
    "mild": "Лёгкая",
    "moderate": "Средняя",
    "severe": "Тяжёлая",
    "occupation": "Профессия",
    "smokingStatus": "Статус курения",
    "alcoholUse": "Употребление алкоголя",
    "exerciseLevel": "Уровень физической активности",
    "never": "Никогда",
    "former": "Бывший",
    "current": "Текущий",
    "none": "Нет",
    "light": "Лёгкое",
    "heavy": "Тяжёлое",
    "sedentary": "Сидячий образ жизни",
    "active": "Активный",
    "veryActive": "Очень активный",
    "saveAndContinue": "Сохранить и перейти к жалобам",
    "treatmentGoals": "Цели лечения",
    "pastMsk": "Предыдущие заболевания опорно-двигательного аппарата",
    "medications": "Текущие лекарства",
    "systemsReview": "Обзор систем",
    "loading": "Загрузка анамнеза...",
    "noSurgical": "Хирургический анамнез не записан.",
    "noFamily": "Семейный анамнез не записан.",
    "searchMedications": "Поиск лекарств",
    "year": "Год",
    "selectBodyRegion": "Выберите область тела",
    "procedureName": "Название процедуры",
    "allergenName": "Название аллергена",
    "pregnancyStatus": "Статус беременности",
    "additionalNotes": "Дополнительные состояния или заметки",
    "shortPastMsk": "МСК ист.",
    "shortMedications": "Лекарства",
    "shortSurgical": "Хирургия",
    "shortFamily": "Семья",
    "shortSystems": "Системы",
    "shortAllergies": "Аллергии",
    "shortLifestyle": "Образ жизни",
    "birthSummary": "Сводка рождения",
    "mothersHealth": "Здоровье матери",
    "immunisations": "Прививки",
    "shortBirth": "Рождение",
    "shortMother": "Мать",
    "shortVaccines": "Вакцины",
    "noCurrentMeds": "Нет текущих лекарств",
    "addFamilyCondition": "Добавить семейное заболевание",
    "noFamilyHistory": "Семейный анамнез не записан.",
    "systemsToggleDesc": "Переключите каждую систему для указания положительных результатов, затем добавьте примечания.",
    "notesPlaceholder": "Примечания к результатам {{system}}...",
    "pregnancyTitle": "Статус беременности",
    "notPregnant": "Не беременна",
    "currentlyPregnant": "Беременна",
    "possiblyPregnant": "Возможна беременность",
    "unknown": "Неизвестно"
  },
  "complaints": {
    "title": "Основные жалобы",
    "side": "Сторона",
    "painLevel": "Уровень боли (NRS)",
    "onset": "Начало",
    "nature": "Характер боли",
    "aggravating": "Усиливающие факторы",
    "relieving": "Облегчающие факторы",
    "radiation": "Иррадиация",
    "dermatome": "Дерматомное распределение",
    "neuroSymptoms": "Неврологические симптомы",
    "functionalImpact": "Функциональное влияние",
    "whichSide": "С какой стороны боль?",
    "left": "Левая",
    "right": "Правая",
    "bilateral": "Двусторонняя",
    "central": "Центральная/По средней линии",
    "noPain": "Нет боли",
    "worstPain": "Сильнейшая боль",
    "sudden": "Внезапное",
    "gradual": "Постепенное",
    "sharp": "Острая",
    "dull": "Тупая",
    "aching": "Ноющая",
    "burning": "Жгучая",
    "shooting": "Стреляющая",
    "throbbing": "Пульсирующая",
    "stabbing": "Колющая",
    "doesRadiate": "Иррадиирует ли боль?",
    "whereRadiate": "Куда именно иррадиирует?",
    "region": "Область",
    "question": "Вопрос",
    "newComplaint": "НОВАЯ",
    "newComplaintNote": "Это новая жалоба (отсутствовала в предыдущем обследовании)",
    "noRegionsSelected": "Области тела не выбраны",
    "loadingComplaint": "Загрузка данных жалобы...",
    "saveAndContinue": "Сохранить и перейти к красным флагам",
    "complaintReview": "Обзор жалоб",
    "aiParsedBadge": "Распознано ИИ · нажмите для подтверждения",
    "confirmError": "Не удалось подтвердить — попробуйте ещё раз",
    "reviewInstructions": "Просмотрите сохранённые жалобы. Вы можете добавить ещё одну область или перейти к проверке красных флагов.",
    "loadingComplaints": "Загрузка жалоб...",
    "noComplaintsSaved": "Жалобы ещё не сохранены. Добавьте хотя бы одну жалобу.",
    "painLabel": "Боль: {{score}}/10",
    "addAnother": "+ Добавить ещё жалобу",
    "maxReached": "Достигнут максимум 5 жалоб",
    "editRedFlags": "Изменить ответы на красные флаги",
    "continueToRedFlags": "Перейти к проверке красных флагов →",
    "complaintsCount": "{{count}} жалоб(а) сохранено",
    "bodyMapInstructions": "Нажмите на области тела, где у пациента есть боль или симптомы. Выберите до 5 областей.",
    "regionsSelected": "{{count}} область(-ей) выбрано",
    "startComplaintDetail": "Начать описание жалобы →",
    "editRegions": "← Изменить области",
    "chronicity": "Как давно у вас эта жалоба?",
    "haLocation": "Где локализуется ваша головная боль?",
    "haCharacter": "Как бы вы описали головную боль?",
    "haDuration": "Как долго длится каждый эпизод?",
    "haFrequency": "Как часто у вас бывают головные боли?",
    "haAssociated": "Испытываете ли вы что-либо из этого вместе с головной болью?",
    "haTriggers": "Что провоцирует или усиливает вашу головную боль?",
    "haRelief": "Что помогает облегчить головную боль?",
    "redFlagScreening": "Проверка красных флагов",
    "dzType": "Как бы вы описали ваше головокружение?",
    "dzTiming": "Как долго длится каждый эпизод?",
    "dzPosition": "Зависит ли ваше головокружение от положения тела?",
    "dzAssociated": "Испытываете ли вы что-либо из этого вместе с головокружением?",
    "dzTriggers": "Что провоцирует ваше головокружение?",
    "paedReporter": "Кто сообщает о симптомах?",
    "paedDailyImpact": "Влияние на повседневную деятельность",
    "paedRecentHistory": "Недавний анамнез",
    "paedDevelopmental": "Вопросы развития",
    "paedFamilyHistory": "Семейный анамнез (педиатрический)",
    "selectDuration": "Выберите длительность симптомов",
    "noDestinations": "Нет конкретных направлений для этой области.",
    "selectDermatome": "Выберите дерматомальное распределение (если определяется):",
    "selectAllApply": "Выберите все подходящие варианты",
    "selectAllApplyMultiType": "Выберите все подходящие варианты — пациент может испытывать несколько типов",
    "selectAllApplyDuration": "Выберите все подходящие варианты — эпизоды могут различаться по длительности",
    "selectTypicalDuration": "Выберите типичную продолжительность каждого эпизода",
    "selectTypicalFrequency": "Выберите типичную частоту",
    "redFlagInstructions": "Ответьте ДА или НЕТ на каждый вопрос. Любой ответ «да» может указывать на необходимость срочного направления.",
    "clinicalNote": "Клиническое примечание",
    "paedReporterHint": "Кто сообщает о симптомах?",
    "paedDailyImpactHint": "Как боль влияет на повседневную деятельность вашего ребёнка? Выберите все подходящие варианты.",
    "paedRecentHistoryHint": "Недавние изменения? Выберите все подходящие варианты.",
    "paedDevelopmentalHint": "Вопросы развития? Выберите все подходящие варианты.",
    "paedFamilyHistoryHint": "Значимый семейный анамнез? Выберите все подходящие варианты.",
    "centralMidline": "Центральная/Срединная линия",
    "centralFrontal": "Центральная/Лобная",
    "occipital": "Затылочная",
    "onsetTraumatic": "Травматическое",
    "onsetInsidious": "Постепенное незаметное",
    "onsetPostSurgical": "Послеоперационное",
    "onsetRepetitiveStrain": "Повторяющаяся нагрузка",
    "onsetUnknown": "Неизвестно",
    "chronicityAcute": "Менее 2 недель (острая)",
    "chronicitySubacute": "2–6 недель (подострая)",
    "chronicityChronic": "6–12 недель (хроническая)",
    "chronicityChronicLong": "Более 12 недель (хроническая)",
    "cramping": "Спазм",
    "tingling": "Покалывание",
    "numbness": "Онемение",
    "radiationNone": "Нет",
    "radiationArm": "В руку",
    "radiationLeg": "В ногу",
    "radiationBack": "По спине",
    "radiationShoulder": "В плечо",
    "radiationHand": "В кисть/пальцы",
    "radiationFoot": "В стопу/пальцы ног",
    "radiationChest": "Вокруг грудной клетки",
    "radiationGroin": "В паховую область",
    "radiationButtock": "В ягодицу",
    "neuroWeakness": "Слабость",
    "neuroBalance": "Потеря равновесия",
    "neuroCoordination": "Потеря координации",
    "neuroAlteredSensation": "Изменённая чувствительность",
    "impactUnableWork": "Невозможность работать",
    "impactReducedWork": "Сниженная работоспособность",
    "impactSleeping": "Трудности со сном",
    "impactDaily": "Трудности с повседневными делами",
    "impactSelfCare": "Трудности с самообслуживанием",
    "impactExercise": "Невозможность заниматься спортом",
    "impactMobility": "Сниженная подвижность",
    "impactSocial": "Социальная замкнутость",
    "impactMood": "Влияние на настроение",
    "impactNone": "Нет значительного влияния",
    "haLocOneSame": "Одна сторона (всегда одна и та же)",
    "haLocOneAlt": "Одна сторона (чередующиеся стороны)",
    "haLocBoth": "Обе стороны / повсеместно",
    "haLocBack": "Затылок / основание черепа",
    "haLocForehead": "Лоб / за глазами",
    "haLocTemple": "Височная область",
    "haLocTop": "Макушка",
    "haCharThrobbing": "Пульсирующая",
    "haCharPressing": "Давящая / сжимающая (как обруч)",
    "haCharSharp": "Острая / колющая",
    "haCharDull": "Тупая / ноющая",
    "haDurSeconds": "Секунды — минуты",
    "haDur30min": "30 минут — 4 часа",
    "haDur4h": "4 — 72 часа",
    "haDurConstant": "Постоянная",
    "haDurVariable": "Различная",
    "haFreqDaily": "Ежедневно или почти ежедневно",
    "haFreqSeveral": "Несколько раз в неделю",
    "haFreqWeekly": "Еженедельно",
    "haFreqMonthly": "Ежемесячно или реже",
    "haFreqEpisodic": "Эпизодически / то появляется, то исчезает",
    "startFromTemplate": "Начать из шаблона",
    "hideMap": "Скрыть карту боли",
    "markLocation": "Отметьте точное расположение боли (необязательно)"
  },
  "physicalExam": {
    "title": "Физический осмотр",
    "selectTests": "Выберите тесты для проведения",
    "recommended": "Рекомендовано",
    "performed": "Проведено",
    "notPerformed": "Не проведено",
    "positive": "Положительный",
    "negative": "Отрицательный",
    "inconclusive": "Неопределённый",
    "notes": "Заметки",
    "addNotes": "Добавить заметки...",
    "testResult": "Результат теста",
    "saveResults": "Сохранить результаты",
    "noTestsSelected": "Тесты не выбраны",
    "selectRegion": "Выберите область тела для просмотра доступных тестов",
    "allTests": "Все тесты",
    "essentialTests": "Основные тесты",
    "recommendedTests": "Рекомендуемые тесты",
    "differentialTests": "Тесты дифференциальной диагностики",
    "additionalTests": "Дополнительные тесты",
    "clinicalGuide": "Руководство по клинической оценке",
    "patternMatch": "Совпадение паттерна",
    "match": "совпадение",
    "basedOnPresentation": "На основе анализа клинической картины",
    "showProcedureDetails": "Показать детали процедуры",
    "primaryTests": "Основные тесты",
    "secondaryTests": "Вторичные тесты",
    "romSpecialized": "ROM / Специализированные",
    "notTested": "Не проведено",
    "left": "Левая",
    "right": "Правая",
    "bilateral": "Двусторонняя",
    "normal": "Норма",
    "restricted": "Ограничено",
    "painful": "Болезненно",
    "hypermobile": "Гипермобильность",
    "noAbnormalities": "Отклонений не обнаружено",
    "noSpinalDysfunction": "Спинальной дисфункции не обнаружено",
    "collapse": "Свернуть",
    "expand": "Развернуть",
    "hideNotes": "Скрыть заметки",
    "clinicalNotes": "Клинические заметки...",
    "searchTests": "Поиск тестов по названию...",
    "all": "Все",
    "essentialDesc": "Обязательно — критически важно для подтверждения/исключения первичных диагнозов",
    "recommendedDesc": "Рекомендуется — укрепляет клиническое мышление",
    "additionalDesc": "При наличии показаний — в зависимости от сложности случая"
  },
  "posture": {
    "manualAssessment": "Ручная оценка",
    "cameraAssessment": "Оценка камерой",
    "shoulderROM": "Объём движений плеча",
    "advancedMeasurements": "Расширенные измерения (14 метрик)",
    "removeImage": "Удалить изображение",
    "cameraDataPopulated": "Данные камеры загружены"
  },
  "investigations": {
    "title": "Исследования",
    "description": "Загрузите снимки (рентген, МРТ, КТ) и/или введите результаты лабораторных анализов. Оба раздела необязательны.",
    "skipAll": "Пропустить всё",
    "imaging": "Визуализация (рентген, МРТ, КТ, УЗИ)",
    "labTests": "Лабораторные анализы (анализ крови, маркеры)"
  },
  "improvement": {
    "previous": "Предыдущее",
    "current": "Текущее",
    "noData": "Нет данных",
    "significantImprovement": "Значительное улучшение",
    "moderateImprovement": "Умеренное улучшение",
    "declining": "Ухудшение",
    "stable": "Стабильно",
    "mcidMet": "MCID ✓",
    "loading": "Загрузка отчёта об улучшении...",
    "noComparisonData": "Данные для сравнения отсутствуют.",
    "reportTitle": "Отчёт об улучшении при повторном обследовании",
    "comparisonSubtitle": "Сравнение с предыдущим обследованием",
    "printReport": "Печать отчёта",
    "painSeverityChanges": "Изменения интенсивности боли",
    "outcomeMeasureChanges": "Изменения показателей исхода",
    "clinicallySignificantChanges": "Клинически значимые изменения",
    "wellnessScore": "Показатель физической формы",
    "mcidExplanation": "MCID = Минимально клинически значимое различие. Изменения, достигающие или превышающие MCID, считаются клинически значимыми.",
    "loadError": "Не удалось загрузить данные сравнения",
    "descNoMeasures": "Нет доступных показателей для сравнения.",
    "descImproved": "{{improved}} из {{total}} показателей улучшились.",
    "descModerate": "{{improved}} из {{total}} показателей улучшились, {{worsened}} ухудшились.",
    "descDeclining": "{{worsened}} из {{total}} показателей ухудшились. Рассмотрите изменение плана.",
    "descMixed": "Смешанные результаты: {{improved}} улучшились, {{worsened}} ухудшились, {{unchanged}} без изменений."
  },
  "reexam": {
    "improved": "Улучшилось",
    "worsened": "Ухудшилось",
    "noChange": "Без изменений",
    "noMeasures": "Нет данных для отображения."
  },
  "paediatricReEvalReport": {
    "title": "Отчёт о прогрессе вашего ребёнка",
    "yearsOld": "{{age}} лет",
    "reEvalFollowup": "Повторный осмотр — контрольный визит",
    "dearParents": "Уважаемые родители,",
    "introText": "Спасибо, что привели {{name}} на повторный приём. Мы рады поделиться тем, как проходит восстановление и какие следующие шаги в плане лечения.",
    "howChildIsDoing": "Как чувствует себя {{name}}",
    "lastVisit": "Последний визит",
    "today": "Сегодня",
    "improvement": "Улучшение",
    "painImprovementMessage": "Это улучшение на {{pct}}%! Отличный прогресс.",
    "greatNews": "Отличные новости!",
    "improvingMessage": "Мы рады слышать, что {{name}} чувствует себя лучше.",
    "muchBetterNote": "Значительное улучшение показывает, что организм ребёнка очень хорошо реагирует на лечение.",
    "worseMessage": "Мы понимаем, что это может беспокоить. Пожалуйста, помните, что прогресс не всегда линеен, особенно у детей. Мы объясним сегодняшние находки и расскажем, как корректируем план, чтобы помочь {{name}}.",
    "noChangeMessage": "Хотя симптомы пока не изменились значительно, это не редкость на ранних стадиях лечения. Мы внимательно отслеживаем прогресс {{name}} и соответственно корректируем план.",
    "developmentalProgress": "Развитие",
    "whatWeFoundToday": "Что мы обнаружили сегодня",
    "whatWeFoundIntro": "Краткое описание текущих состояний {{name}} и их динамики:",
    "statusImproving": "Улучшается",
    "statusStable": "Стабильно",
    "statusNeedsAttention": "Требует внимания",
    "statusUnderReview": "На наблюдении",
    "monitoring": "Мы отслеживаем это состояние в рамках плана лечения {{name}}.",
    "noConditionsConfirmed": "На данный момент подтверждённых состояний нет.",
    "updatedTreatmentPlan": "Обновлённый план лечения для {{name}}",
    "updatedPlanIntro": "На основании сегодняшних находок вот обновлённый план лечения {{name}}:",
    "whatYouCanDoAtHome": "Что можно делать дома",
    "infantTitle": "Советы для младенцев (0-1 год)",
    "infantTummyTime": "Время на животе:",
    "infantTummyTimeText": "3-5 минут несколько раз в день, постепенно увеличивая",
    "infantFeeding": "Кормление:",
    "infantFeedingText": "Чередуйте стороны при кормлении для симметричного движения",
    "infantCarrying": "Ношение:",
    "infantCarryingText": "Чередуйте положения при ношении — на бедре, лицом вперёд, сидя с поддержкой",
    "infantSleep": "Сон:",
    "infantSleepText": "Укладывать спать на спину, чередовать положение головы при каждом сне",
    "infantPlay": "Игра:",
    "infantPlayText": "Используйте игрушки, чтобы поощрять движение в обе стороны",
    "toddlerTitle": "Советы для малышей (1-3 года)",
    "toddlerMovement": "Движение:",
    "toddlerMovementText": "Поощряйте лазание, ползание через туннели и упражнения на равновесие",
    "toddlerShoes": "Обувь:",
    "toddlerShoesText": "Выбирайте гибкую поддерживающую обувь — босиком дома, когда безопасно",
    "toddlerWalking": "Походка:",
    "toddlerWalkingText": "Лёгкое хождение на носках или носками внутрь часто нормально в этом возрасте",
    "toddlerActivities": "Активности:",
    "toddlerActivitiesText": "Танцы, игра с мягким мячом и мягкие прыжки помогают координации",
    "childTitle": "Советы для детей (3-12 лет)",
    "childSport": "Спорт и активность:",
    "childSportText": "60 минут физической активности ежедневно — разнообразие полезнее всего",
    "childBackpack": "Рюкзак:",
    "childBackpackText": "Вес не более 10-15% веса тела, использовать обе лямки",
    "childScreen": "Осанка у экрана:",
    "childScreenText": "Глаза на уровне экрана, ступни на полу, перерывы каждые 20-30 минут",
    "childFun": "Весёлые упражнения:",
    "childFunText": "«Походки животных» (медведь, краб), «позы супергероя» и «ангелы у стены»",
    "childRest": "Отдых и активность:",
    "childRestText": "При лёгкой боли мягкая активность обычно помогает больше, чем полный покой",
    "adolescentTitle": "Советы для подростков (12-18 лет)",
    "adolescentSport": "Для конкретного вида спорта:",
    "adolescentSportText": "Правильная разминка, не играть через значительную боль",
    "adolescentGrowth": "Скачки роста:",
    "adolescentGrowthText": "Дополнительная растяжка во время роста предотвращает скованность",
    "adolescentStudy": "Осанка при учёбе/играх:",
    "adolescentStudyText": "Настройте рабочее место на правильной высоте, делайте регулярные перерывы",
    "adolescentStrength": "Укрепление:",
    "adolescentStrengthText": "Упражнения с собственным весом (планки, приседания, выпады) создают прочную базу",
    "adolescentReturn": "Когда вернуться:",
    "adolescentReturnText": "Свяжитесь с нами, если боль усиливается, переходит в новую область или мешает повседневной жизни",
    "specificHomeAdvice": "Конкретные рекомендации по домашнему уходу:",
    "do": "Делайте:",
    "avoid": "Избегайте:",
    "recommendedExercises": "Рекомендуемые упражнения:",
    "whenToContactUs": "Когда связаться с нами",
    "contactImmediatelyIf": "Свяжитесь с нами немедленно, если:",
    "contactImmediate1": "у {{name}} появилась температура с болью в суставах",
    "contactImmediate2": "{{name}} отказывается использовать конечность или опираться на неё",
    "contactImmediate3": "Сильная боль, усиливающаяся несмотря на отдых",
    "contactImmediate4": "Вы замечаете новый отёк, покраснение или тепло вокруг сустава",
    "contactImmediate5": "Внезапное изменение походки или движений {{name}}",
    "bookSoonerIf": "Запишитесь на более ранний приём, если:",
    "bookSooner1": "Боль не улучшается через 2 недели",
    "bookSooner2": "Появляются новые симптомы",
    "bookSooner3": "У вас есть любые опасения по поводу прогресса {{name}}",
    "otherwiseSeeAgain": "В противном случае мы увидим {{name}} снова по расписанию плана лечения выше.",
    "noteForParents": "Обращение к родителям",
    "parentsNote1": "Мы понимаем, что видеть ребёнка в боли или дискомфорте может быть тревожно. Знайте, что состояние {{name}} распространено, поддаётся лечению и реагирует на терапию. Дети удивительно устойчивы, и при правильной поддержке большинство опорно-двигательных проблем в детстве успешно разрешаются. Мы здесь, чтобы провести вас и {{name}} через этот путь.",
    "growingPainsTitle": "О болях роста:",
    "growingPainsNote": "Боли роста — нормальная часть детства и НЕ указывают на проблемы с костями или суставами. Они временны и проходят по мере взросления. Тёплая ванна перед сном и мягкий массаж болезненной области могут помочь.",
    "parentsNote2": "Если у вас есть вопросы между приёмами, пожалуйста, свяжитесь с нами. Ни один вопрос не является слишком мелким, когда речь идёт о здоровье вашего ребёнка.",
    "nextSteps": "Следующие шаги",
    "readyToBook": "Готовы записать {{name}} на следующий приём?",
    "scanToBook": "Сканируйте для записи",
    "referralTitle": "Знаете другую семью, которой мы можем помочь?",
    "referralText": "Мы будем рады помочь вашей семье и друзьям. Если вы знаете ребёнка, которому могла бы помочь наша забота, мы будем рады его принять.",
    "disclaimer": "Этот отчёт предназначен для родителей/опекунов пациента и носит информационный характер. Он не заменяет медицинскую консультацию. При любых беспокойствах о здоровье ребёнка обратитесь к врачу.",
    "reliefCare": "Терапия Облегчения",
    "rehabilitation": "Реабилитация",
    "wellnessCare": "Поддерживающая забота"
  },
  "paediatricProgress": {
    "loading": "Загрузка данных о прогрессе...",
    "title": "Прогресс с последнего визита",
    "painLevels": "Уровни боли",
    "improving": "Улучшается",
    "worsening": "Ухудшается",
    "stable": "Стабильно",
    "resolved": "Устранено",
    "new": "Новое",
    "errorLoad": "Не удалось загрузить данные о прогрессе",
    "retry": "Повторить",
    "empty": "Нет данных предыдущего визита для сравнения",
    "parentConcernChanges": "Изменения в опасениях родителей",
    "ongoing": "Продолжающиеся",
    "treatmentResponseTitle": "Ответ на лечение (по словам родителей)",
    "developmentalMilestonesTitle": "Достигнутые этапы развития",
    "exerciseCompliance": "Соблюдение упражнений",
    "outcomeMeasures": "Измерения результатов",
    "wellnessScore": "Показатель физической формы"
  },
  "paediatricReEval": {
    "title": "Анкета родителя / опекуна",
    "subtitle": "Пожалуйста, ответьте на следующие вопросы о состоянии вашего ребёнка с момента последнего визита.",
    "loading": "Загрузка анкеты…",
    "errorLoad": "Не удалось загрузить анкету. Пожалуйста, попробуйте ещё раз.",
    "empty": "Нет предыдущих данных — начните отвечать на вопросы ниже.",
    "retry": "Повторить",
    "savedDraft": "Ответы сохранены",
    "saveError": "Не удалось сохранить ответ. Пожалуйста, попробуйте ещё раз.",
    "completed": "Анкета заполнена — спасибо!",
    "sectionParentConcerns": "Вопросы родителя",
    "sectionDevelopment": "Развитие",
    "sectionTreatmentResponse": "Реакция на лечение",
    "devBanner": "Проверка развития — эти вопросы помогают нам отслеживать этапы развития вашего ребёнка.",
    "continue": "Продолжить →",
    "back": "← Назад",
    "complete": "✓ Завершить анкету и продолжить",
    "noPain": "Нет боли",
    "worstPain": "Сильнейшая боль",
    "q1": {
      "title": "В1: Как себя чувствует ваш ребёнок с момента последнего визита?",
      "options": {
        "Much better": "Значительно лучше",
        "Slightly better": "Немного лучше",
        "No change": "Без изменений",
        "Slightly worse": "Немного хуже",
        "Much worse": "Значительно хуже"
      }
    },
    "q2": {
      "title": "В2: Что вас беспокоит сегодня больше всего?",
      "options": {
        "Pain is still present": "Боль всё ещё присутствует",
        "Pain has moved to a different area": "Боль переместилась в другую область",
        "New symptoms have appeared": "Появились новые симптомы",
        "Child is not improving as expected": "Ребёнок не поправляется, как ожидалось",
        "Child is avoiding activities": "Ребёнок избегает активности",
        "Sleep is still disturbed": "Сон по-прежнему нарушен",
        "Concerned about posture": "Беспокоит осанка",
        "Concerned about development": "Беспокоит развитие",
        "Limping or favouring one side": "Хромает или щадит одну сторону",
        "School/sports participation affected": "Страдает участие в школе/спорте",
        "No concerns — here for routine check": "Нет беспокойств — плановый осмотр"
      }
    },
    "q3": {
      "title": "В3: Что-нибудь изменилось с последнего визита?",
      "options": {
        "Started a new sport or activity": "Начал новый вид спорта или активности",
        "Had a fall or injury": "Падение или травма",
        "Been unwell (illness, fever)": "Болел (болезнь, температура)",
        "Growth spurt noticed": "Замечен скачок роста",
        "Started or stopped medication": "Начал или прекратил приём лекарств",
        "Changed shoes or school bag": "Сменил обувь или школьную сумку",
        "Nothing has changed": "Ничего не изменилось"
      }
    },
    "q4": {
      "title": "В4: Как ребёнок справляется эмоционально?",
      "options": {
        "Happy and active as usual": "Весёлый и активный как обычно",
        "A bit frustrated by the limitation": "Немного расстроен ограничениями",
        "Anxious about the condition": "Тревожится о состоянии",
        "Withdrawn or less active than usual": "Замкнут или менее активен",
        "No noticeable change": "Заметных изменений нет"
      }
    },
    "q5": {
      "title": "В5: Выполнял ли ребёнок домашние упражнения / рекомендации?",
      "options": {
        "Yes, consistently": "Да, регулярно",
        "Yes, but not regularly": "Да, но не регулярно",
        "Sometimes": "Иногда",
        "Rarely": "Редко",
        "Not at all": "Совсем нет",
        "Exercises were not prescribed": "Упражнения не назначались"
      }
    },
    "q6": {
      "title": "В6: По шкале от 0 до 10 оцените боль ребёнка сейчас"
    },
    "q7": {
      "title": "В7: Заметили ли вы изменения в движениях ребёнка с последнего визита?",
      "options": {
        "Moving more freely": "Двигается более свободно",
        "Started crawling / walking / running (milestone achieved)": "Начал ползать / ходить / бегать (новый этап)",
        "Seems less coordinated than before": "Кажется менее координированным",
        "Head control has improved": "Улучшился контроль головы",
        "Still favouring one side": "По-прежнему щадит одну сторону",
        "No change noticed": "Изменений не замечено"
      }
    },
    "q8": {
      "title": "В8: Есть ли проблемы с кормлением?",
      "options": {
        "Feeding well from both sides": "Хорошо кормится с обеих сторон",
        "Still prefers one side": "По-прежнему предпочитает одну сторону",
        "Difficulty latching or feeding": "Трудности с захватом или кормлением",
        "No concerns": "Нет беспокойств"
      }
    },
    "q9": {
      "title": "В9: Как ребёнок спит?",
      "options": {
        "Sleeping well through the night": "Спит хорошо всю ночь",
        "Waking due to discomfort": "Просыпается из-за дискомфорта",
        "Sleeping in an unusual position": "Спит в необычной позе",
        "Sleep has improved since last visit": "Сон улучшился с последнего визита",
        "No change": "Без изменений"
      }
    },
    "q10": {
      "title": "В10: Какие процедуры получал ребёнок с последнего визита?",
      "options": {
        "Chiropractic adjustments": "Хиропрактические коррекции",
        "Soft tissue therapy": "Терапия мягких тканей",
        "Exercise therapy": "Лечебная физкультура",
        "Home exercises only": "Только домашние упражнения",
        "Other healthcare provider treatment": "Лечение у другого специалиста",
        "No treatment received": "Лечение не проводилось"
      }
    },
    "q11": {
      "title": "В11: Как ребёнок отреагировал на лечение?",
      "options": {
        "Pain reduced after treatment": "Боль уменьшилась после лечения",
        "More mobile after treatment": "Стал более подвижным после лечения",
        "Temporary soreness after treatment (normal)": "Временная болезненность после лечения (норма)",
        "No noticeable effect": "Заметного эффекта нет",
        "Symptoms worsened after treatment (important to note)": "Симптомы ухудшились после лечения (важно отметить)"
      }
    }
  },
  "outcomeMeasures": {
    "title": "Показатели исхода",
    "recommended": "рекомендовано на основе областей жалоб",
    "vasAlreadyCaptured": "Оценка боли по VAS уже записана в разделе жалоб.",
    "skipMeasures": "Пропустить показатели исхода",
    "measureOf": "Показатель {{current}} из {{total}}",
    "allComplete": "Все рекомендованные показатели заполнены",
    "saveAndContinue": "Сохранить и продолжить",
    "ndi": "Индекс нетрудоспособности шеи",
    "odi": "Индекс нетрудоспособности Освестри",
    "dash": "DASH (Нарушения руки, плеча, кисти)",
    "lefs": "Шкала функциональности нижних конечностей",
    "phq9": "Опросник здоровья пациента-9",
    "gad7": "Генерализованное тревожное расстройство-7",
    "startBack": "Инструмент скрининга STarT Back",
    "tsk11": "Шкала кинезиофобии Тампа-11",
    "severity": {
      "noDisability": "Нет ограничений",
      "mild": "Лёгкая",
      "moderate": "Средняя",
      "severe": "Тяжёлая",
      "fairlySevere": "Довольно тяжёлая",
      "verySevere": "Очень тяжёлая",
      "complete": "Полная нетрудоспособность"
    }
  },
  "ddx": {
    "title": "Обзор дифференциальной диагностики",
    "confidence": {
      "strong": "Высокая",
      "probable": "Вероятная",
      "possible": "Возможная",
      "lessLikely": "Маловероятная",
      "unlikely": "Невероятная"
    },
    "status": {
      "suggested": "Предложено",
      "confirmed": "Подтверждено",
      "overridden": "Отменено",
      "rejected": "Отклонено",
      "clinicianAdded": "Добавлено клиницистом",
      "notSelected": "Не выбрано"
    },
    "confirmBtn": "Подтвердить",
    "rejectBtn": "Отклонить",
    "overrideBtn": "Отменить",
    "showEvidence": "Показать доказательства",
    "hideEvidence": "Скрыть доказательства",
    "redFlagStatus": "Статус красных флагов",
    "acknowledged": "Подтверждено",
    "allRedFlagsRequired": "Все красные флаги должны быть подтверждены перед завершением",
    "aiSecondOpinion": "Необязательно: второе мнение ИИ",
    "analyzing": "Анализ...",
    "getAiOpinion": "Получить мнение ИИ",
    "refreshAiOpinion": "Обновить мнение ИИ",
    "noAiSuggestions": "Нет дополнительных предложений от ИИ",
    "ruleBasedComplete": "Анализ на основе правил завершён",
    "clusterAnalysis": "Кластерный анализ",
    "conditions": "Состояния",
    "commonFindings": "Общие находки",
    "systemicAlerts": "Системные паттерны",
    "finalizeAssessment": "Завершить обследование",
    "finalizing": "Завершение...",
    "workingHypotheses": "Рабочие гипотезы",
    "confirmed": "Подтверждено",
    "confidenceLabel": "вероятность",
    "acknowledgeAndConfirm": "Подтвердить и принять",
    "supportingEvidence": "Подтверждающие доказательства",
    "addConditionManually": "Добавить состояние вручную",
    "searchAndAdd": "Найти и добавить состояние",
    "searchPlaceholder": "Поиск по названию, коду МКБ или области тела...",
    "noMatchingConditions": "Совпадающих состояний не найдено",
    "typeToSearch": "Введите минимум 2 символа для поиска",
    "confirmAtLeastOne": "Подтвердите хотя бы одну рабочую гипотезу перед завершением.",
    "crossComplaintAlerts": "Перекрёстные паттерны жалоб",
    "clinicalNote": "Клиническая заметка",
    "referTo": "Направить к",
    "additionalTests": "Дополнительные тесты",
    "matchedCriteria": "Совпавшие критерии",
    "selectTop3": "Выбрать топ-3",
    "selectBtn": "Выбрать",
    "confirmedCount": "{{confirmed}} / {{total}} подтверждено",
    "emergency": "ЭКСТРЕННО",
    "medicalEmergency": "МЕДИЦИНСКАЯ ЭКСТРЕННАЯ СИТУАЦИЯ",
    "emergencyAction": "МЕДИЦИНСКАЯ ЭКСТРЕННАЯ СИТУАЦИЯ — Требуется немедленное действие",
    "emergencyFlags": "ФЛАГИ МЕДИЦИНСКОЙ ЭКСТРЕННОЙ СИТУАЦИИ",
    "critical": "КРИТИЧНО",
    "loadingReview": "Загрузка обзора DDx...",
    "noData": "Данные недоступны.",
    "selectHint": "Нажмите <strong>Выбрать</strong> для подтверждения рабочих гипотез. Только подтверждённые состояния включаются в план лечения.",
    "hypothesisCount_one": "{{count}} гипотеза",
    "hypothesisCount_other": "{{count}} гипотез",
    "skipAiSuggestions": "Пропустить предложения ИИ",
    "acceptBtn": "✓ Принять",
    "accepted": "✓ Принято",
    "aiSuggestion": "Предложение ИИ",
    "aiDismissed": "Предложения ИИ отклонены. Продолжение только с ручной DDx.",
    "aiComprehensive": "Нет дополнительных предложений от ИИ. Анализ на основе правил представляется исчерпывающим.",
    "aiClinicalNotes": "Клинические заметки ИИ",
    "aiDescription": "Анализ на основе правил завершён. Хотите второе мнение ИИ?",
    "reasoning": "Обоснование:",
    "keyFindings": "Ключевые находки:",
    "recommendedTests": "Рекомендуемые тесты для подтверждения/исключения:",
    "hideDetails": "Скрыть детали",
    "showDetails": "Показать детали",
    "regions": {
      "lumbar": "Поясничный (Нижняя часть спины)",
      "cervical": "Шейный (Шея)",
      "thoracic": "Грудной (Средняя часть спины)",
      "shoulder": "Плечо",
      "shoulder_left": "Левое плечо",
      "shoulder_right": "Правое плечо",
      "knee": "Колено",
      "knee_left": "Левое колено",
      "knee_right": "Правое колено",
      "hip": "Тазобедренный",
      "hip_left": "Левый тазобедренный",
      "hip_right": "Правый тазобедренный",
      "elbow": "Локоть",
      "elbow_left": "Левый локоть",
      "elbow_right": "Правый локоть",
      "wrist_hand": "Запястье/Кисть",
      "wrist_hand_left": "Левое запястье/кисть",
      "wrist_hand_right": "Правое запястье/кисть",
      "ankle_foot": "Голеностоп/Стопа",
      "ankle_foot_left": "Левый голеностоп/стопа",
      "ankle_foot_right": "Правый голеностоп/стопа",
      "tmj": "ВНЧС / Челюсть"
    },
    "card": {
      "regions": "Области:"
    },
    "acknowledgeAndDismiss": "Подтвердить и отклонить",
    "dismissed": "Отклонено",
    "restoreDismissed": "Восстановить гипотезу",
    "dismissReasonLabel": "Причина отклонения (обязательно, мин. 5 символов)",
    "dismissReasonPlaceholder": "напр. Нет седловидной анестезии, нормальная функция мочевого пузыря, полный безболезненный объём движений",
    "dismissConfirm": "Отклонить с указанием причины",
    "dismissCancel": "Отмена",
    "escalateForEmergency": "Эскалация для экстренной оценки",
    "escalateExplainer": "Только этот переключатель добавляет формулировки экстренного направления в письма врачам/страховым.",
    "escalateAction": "Эскалировать",
    "escalationActive": "Эскалация ВКЛ",
    "acknowledgeFlag": "Подтвердить и отклонить флаг",
    "confirmDifferential": "Подтвердить дифференциальный диагноз",
    "confirming": "Подтверждение...",
    "confirmedToast": "Дифференциальный диагноз подтверждён — проверьте план ведения. Отчёт формируется при нажатии «Завершить»."
  },
  "careJourney": {
    "painRelief": {
      "title": "Терапия Облегчения",
      "duration": "2–6 недель",
      "description": "Первый приоритет — снижение боли и успокоение тканей. Мы сосредотачиваемся на щадящем лечении, коротких визитах и простых домашних рекомендациях, чтобы вы могли спать, двигаться и работать с меньшим дискомфортом."
    },
    "rehabilitation": {
      "title": "Реабилитация",
      "duration": "6 недель – 6 месяцев",
      "description": "Как только боль под контролем, мы восстанавливаем силу, подвижность и качество движений. Лечение становится реже, а вы выполняете больше активных упражнений — именно эта фаза закрепляет улучшение."
    },
    "maintenance": {
      "title": "Поддерживающая забота",
      "duration": "Постоянно",
      "description": "Периодические осмотры сохраняют достигнутые улучшения. Мы проверяем осанку, движение и ранние признаки проблем, корректируя при необходимости, чтобы мелкие вопросы не превратились в серьёзные."
    }
  },
  "managementPlan": {
    "title": "План лечения",
    "panel": {
      "phases": {
        "title": "Этапы лечения",
        "phaseLabel": "Этап"
      },
      "frequency": {
        "title": "Частота лечения",
        "empty": "Блоков частоты пока нет. Выберите пресет выше или нажмите \"Добавить блок\", чтобы начать."
      }
    },
    "preset": {
      "rowLabel": "Пресет"
    },
    "block": {
      "add": "Добавить блок",
      "delete": "Удалить",
      "labelAria": "Метка блока",
      "frequencyPlaceholder": "напр. 3x/нед",
      "durationPlaceholder": "недели",
      "visitsPlaceholder": "визиты",
      "deleteMaintenanceConfirm": "Удалить блок Поддержания? У пациента не останется блока продолжающейся помощи после активных этапов."
    },
    "maintenance": {
      "label": "Поддержание"
    },
    "generatePlan": "Создать план",
    "regeneratePlan": "Пересоздать план",
    "generating": "Создание...",
    "completeDdxFirst": "Сначала завершите шаг обзора ДДх",
    "needConfirmedHypothesis": "План лечения требует хотя бы одну подтверждённую рабочую гипотезу",
    "noPlanYet": "План лечения ещё не создан. Нажмите \"Создать план\" для создания комплексного плана на основе подтверждённых состояний.",
    "confirmedConditions": "Подтверждённые состояния",
    "expectedDuration": "Ожидаемая общая длительность",
    "treatmentPhases": "Фазы лечения",
    "precautions": "Меры предосторожности и предупреждения",
    "referralCriteria": "Критерии направления",
    "supplements": "Рекомендации по добавкам",
    "supplementsClinicianOnly": "Справочная информация для клинициста, не для материалов пациенту",
    "evidenceBase": "Доказательная база",
    "phase": "Фаза {{num}}:",
    "duration": "Длительность:",
    "frequency": "Частота:",
    "techniques": "Техники",
    "goals": "Цели",
    "condition": "Состояние",
    "criteria": "Критерии",
    "urgency": "Срочность",
    "routine": "плановая",
    "urgent": "срочная",
    "emergent": "экстренная",
    "every2weeks": "Каждые 2 недели",
    "every3weeks": "Каждые 3 недели",
    "every4weeks": "Каждые 4 недели (Ежемесячно)",
    "every6weeks": "Каждые 6 недель",
    "ongoingWellness": "Постоянный оздоровительный уход",
    "selfLimiting": "Самоограничивающееся состояние",
    "expectedTimeline": "Ожидаемые сроки",
    "evidence": {
      "levelA": "Уровень А — Сильный",
      "levelB": "Уровень Б — Умеренный",
      "levelC": "Уровень В — Ограниченный"
    },
    "loadingSupplements": "Загрузка добавок...",
    "regenerate": "Пересоздать план",
    "generate": "Создать план",
    "requiresHypothesis": "План лечения требует хотя бы одной подтверждённой рабочей гипотезы.",
    "goToDdx": "← Перейти к обзору ДДх",
    "addressesConditions": "План лечения охватывает {{count}} состояний",
    "acrossRegions": "В {{count}} областях",
    "treatmentGoals": "Цели лечения пациента",
    "goalsSelected": "{{count}} целей выбрано — план лечения будет согласован с этими задачами.",
    "visitSchedule": "График визитов",
    "phase1": "Блок 1",
    "phase2": "Блок 2",
    "phase3": "Блок 3",
    "understanding": "Понимание ваших состояний",
    "treatmentJourney": "Ваш путь лечения",
    "acutePhase": "Терапия Облегчения",
    "rehabPhase": "Реабилитация",
    "maintenancePhase": "Поддержание",
    "visitFrequency": "Рекомендуемая частота визитов",
    "homeExercises": "Что можно делать дома",
    "paediatricGuidance": "Педиатрические рекомендации",
    "exerciseProgrammePdf": "PDF программы упражнений",
    "generated": "Создано",
    "infantGoals": "Цели лечения для вашего малыша",
    "treatmentsConcurrent": "лечение проводится параллельно",
    "clinicianOverride": "Корректировка врача",
    "scheduleDescription": "Протоколы лечения проверены на соответствие актуальным клиническим данным. Скорректируйте график ниже при необходимости.",
    "visitsPerWeek": "визитов/неделю",
    "for": "в течение",
    "weeks": "Недели",
    "visits": "визитов",
    "phase3Ongoing": "Поддержание",
    "reExamSchedule": "График повторных осмотров",
    "reExamsAtWeek": "Повторные осмотры на неделе",
    "addReExamWeek": "Добавить неделю повторного осмотра",
    "removeLastReExam": "Удалить последний повторный осмотр",
    "scheduleSummary": "Блоки 1+2: ~{{totalVisits}} визитов за ~{{totalWeeks}} недель + Поддержание: каждые {{maintenanceWeeks}} недель (постоянно)",
    "resetToDefaults": "Сбросить к настройкам по умолчанию",
    "whatDoesThisMean": "Что это значит?",
    "whatIsThis": "Что это такое?",
    "howDoesItHappen": "Как это происходит?",
    "whatCanBeDone": "Что можно сделать?",
    "whatToExpect": "Чего ожидать",
    "whenToWorry": "Когда стоит беспокоиться",
    "do": "РЕКОМЕНДУЕТСЯ",
    "avoid": "ИЗБЕГАТЬ",
    "contraindications": "Противопоказания",
    "recommendedApproach": "Рекомендуемый подход",
    "clinicServices": "Услуги клиники",
    "noSupplementsYet": "Рекомендации по добавкам пока не созданы. Они создаются автоматически при генерации плана лечения.",
    "grade": "Класс",
    "dosage": "Дозировка",
    "timing": "Время приёма",
    "highSeverityWarning": "Обнаружено взаимодействие высокой степени тяжести — рассмотрите отключение этой добавки",
    "disableSupplement": "Отключить добавку",
    "enableSupplement": "Включить добавку",
    "active": "активных",
    "total": "всего",
    "citations": "цитирований",
    "effect": "Эффект",
    "evidenceLevelsDescription": "Уровни доказательности: A = Высококачественные РКИ/мета-анализы, B = Доказательства среднего качества, C = Экспертный консенсус/серии случаев",
    "failedToGenerate": "Не удалось создать план",
    "exercisePdfError": "Ошибка PDF упражнений",
    "downloadFailed": "Загрузка не удалась",
    "goalLabels": {
      "pain_relief": "Облегчение боли",
      "return_to_sport": "Возврат к спорту/активности",
      "improve_posture": "Улучшение осанки",
      "prevent_recurrence": "Помощь в снижении риска рецидива",
      "improve_mobility": "Улучшение подвижности/гибкости",
      "manage_chronic": "Управление хроническим состоянием",
      "pre_post_surgical": "Пред-/послеоперационная реабилитация",
      "general_wellness": "Общее оздоровление",
      "symptom_resolution": "Устранение симптомов",
      "improve_movement": "Улучшение движения и симметрии",
      "support_development": "Поддержка этапов развития",
      "feeding_comfort": "Улучшение комфорта кормления",
      "sleep_improvement": "Улучшение качества сна",
      "parent_confidence": "Укрепление уверенности родителей",
      "head_shape": "Улучшение формы головы",
      "prevent_secondary": "Предотвращение вторичных проблем"
    },
    "regions": {
      "lumbar": "Поясничный отдел (Нижняя часть спины)",
      "cervical": "Шейный отдел (Шея)",
      "thoracic": "Грудной отдел (Средняя часть спины)",
      "shoulder": "Плечо",
      "knee": "Колено",
      "hip": "Тазобедренный сустав",
      "elbow": "Локоть",
      "wrist": "Запястье/Кисть",
      "ankle": "Голеностоп/Стопа",
      "general": "Общее"
    },
    "visitWarning": {
      "title": "Количество визитов ниже типичного диапазона плана ведения",
      "body": "Запланированное количество визитов ниже типичного диапазона плана ведения для данной степени тяжести. Оцените, является ли меньшее количество визитов намеренным решением (ожидается быстрый ответ на лечение, предпочтение пациента, лёгкая клиническая картина) или будет целесообразен план краткой повторной оценки.",
      "severity": {
        "mild": "лёгкого",
        "moderate": "средней тяжести",
        "moderateSevere": "умеренно-тяжёлого",
        "severe": "тяжёлого"
      }
    },
    "severityTier": {
      "mildModerate": "Лёгко-умеренная",
      "moderate": "Умеренная",
      "moderateSevere": "Умеренно-тяжёлая",
      "moderateHigh": "Умеренно-высокая",
      "high": "Высокая"
    },
    "moderateExplanation": "Ваши симптомы указывают на умеренный уровень общей выраженности, поскольку затронуто более одной области, а самая высокая оценка боли, которую вы указали, составляет 6/10. Это не означает, что было обнаружено что-то опасное, но помогает нам планировать ваше лечение и отслеживать динамику.",
    "reexamPoints": {
      "title": "Повторные осмотры",
      "add": "Добавить осмотр",
      "empty": "Повторные осмотры не запланированы. Добавьте один, чтобы привязать контрольную оценку прогресса к запланированному визиту.",
      "visitOption": "Визит {{n}} (неделя {{w}})",
      "missingVisit": "Визит {{n}} (больше не запланирован)",
      "invalidWarning": "Этот визит больше не существует — исключён из отчёта до исправления.",
      "remove": "Удалить"
    },
    "genericTemplate": "общий шаблон",
    "genericTemplateHint": "Протокол для этого состояния не задан; это общий шаблон из 3 фаз."
  },
  "report": {
    "title": "Клинический отчёт",
    "generate": "Создать отчёт",
    "regenerate": "Пересоздать",
    "format": "Формат отчёта",
    "compact": "Краткий",
    "comprehensive": "Подробный",
    "selectLanguage": "Язык отчёта",
    "selectSections": "Разделы для включения",
    "printReport": "Печать отчёта",
    "downloadPdf": "Скачать PDF",
    "generatedOn": "Создано",
    "disclaimer": "Данный отчёт содержит рабочие гипотезы только для клинического рассмотрения. Он не является окончательным диагнозом.",
    "includeLetterhead": "Включить фирменный бланк клиники",
    "enhanceWithAi": "Улучшить с помощью ИИ",
    "selectAtLeastOne": "Выберите хотя бы один раздел",
    "aiSummary": "ИИ-улучшенная сводка (необязательно)",
    "dismiss": "Закрыть",
    "keyPoints": "Ключевые моменты",
    "nextSteps": "Рекомендуемые следующие шаги",
    "clinicalReport": "Отчёт о клиническом обследовании",
    "compactReport": "краткий отчёт",
    "comprehensiveReport": "подробный отчёт",
    "bookAppointment": "Запишитесь на следующий приём",
    "callUs": "Звоните:",
    "emailUs": "Email:",
    "visitUs": "Адрес:",
    "openingHours": "Часы работы:",
    "followInstagram": "Мы в Instagram:",
    "scanToBook": "Отсканируйте для записи на следующий приём",
    "confidential": "Конфиденциально",
    "was": "Было",
    "now": "Сейчас",
    "before": "До",
    "better": "лучше",
    "improvement": "улучшение",
    "outcomeMeasureDeltas": "Изменения показателей исхода",
    "outcomeMeasureChanges": "Изменения показателей исхода",
    "measure": "Показатель",
    "change": "Изменение",
    "significance": "Значимость",
    "whyOngoingCare": "Почему важно регулярное наблюдение",
    "painRelief": "Обезболивание",
    "rehabilitation": "Реабилитация",
    "maintenance": "Поддержание",
    "peakPerformance": "Пиковая производительность",
    "emailReport": "Отправить отчёт пациенту по email",
    "emailInstructions": "Введите email пациента для отправки копии отчёта",
    "patientEmailOverride": "Email пациента (необязательная замена)",
    "sendReport": "Отправить отчёт",
    "sending": "Отправка...",
    "sections": {
      "patient_info": "Информация о пациенте",
      "chief_complaints": "Основные жалобы",
      "medical_history": "Медицинский анамнез",
      "examination_findings": "Результаты осмотра",
      "imaging_results": "Результаты визуализации",
      "diagnosis": "Диагноз (Дифф)",
      "treatment_plan": "План лечения",
      "wellness_score": "Оценка физической формы",
      "red_flags": "Тревожные признаки",
      "referrals": "Направления",
      "supplement_plan": "Рекомендации по добавкам"
    },
    "yourCarePathway": "Путь к Прогрессу",
    "phase1PainRelief": "1. Обезболивающий уход",
    "phase1Desc": "Фаза восстановления — избавляет от боли",
    "phase2Rehab": "2. Реабилитация",
    "phase2Desc": "Фаза улучшения — укрепляет вашу устойчивость",
    "phase3Wellness": "3. Поддерживающая забота",
    "phase3Desc": "Фаза оптимизации — поддерживает вас на пике",
    "didYouKnow": "Знаете ли вы?",
    "didYouKnowText": "Регулярные осмотры помогают нам отслеживать ваш прогресс, выявлять изменения в подвижности или функции на ранней стадии и поддерживать ваше самостоятельное лечение. Для многих пациентов постоянный уход помогает оставаться активными и снижает вероятность обострений.",
    "knowSomeone": "Знаете кого-то, кому это может помочь?",
    "knowSomeoneText": "Мы будем рады помочь вашей семье и друзьям. Если вы знаете кого-то, кому может помочь наша забота, мы будем рады принять их.",
    "outOf100": "из 100",
    "zone": "Зона",
    "treatmentGoals": "Ваши цели лечения:",
    "whenToContact": "Когда связаться с нами",
    "dearGuardianOf": "Родитель/опекун",
    "dearPatient": "Уважаемый(ая)",
    "thankYouBringing": "Благодарим, что привели {name} в {clinic}. Ниже представлено резюме наших результатов.",
    "ongoingCareIntro": "Как вы посещаете стоматолога каждые 6 месяцев для здоровья зубов, так и ваш позвоночник и опорно-двигательная система нуждаются в регулярных осмотрах. Эти визиты помогают выявить небольшие проблемы до того, как они станут серьёзными.",
    "evidenceCareParagraph": "Боль в спине и шее может уменьшаться, но симптомы иногда возвращаются — особенно если не учитывать такие факторы, как рабочая поза, стресс, мышечная слабость, скованность, тренировочная нагрузка или образ жизни. Исследования поддерживают мануальную терапию, включая манипуляции на позвоночнике, как один из вариантов помощи при боли в пояснице, особенно в сочетании с упражнениями, реабилитацией, обучением пациента и самостоятельным управлением состоянием. У отдельных пациентов с рецидивирующей или стойкой болью в пояснице, которые хорошо реагируют на первоначальную хиропрактическую помощь, поддерживающая терапия может уменьшить количество дней с беспокоящей болью в пояснице в течение 12 месяцев по сравнению с обращением за помощью только при возвращении симптомов.",
    "evidenceCitation": "На основе: NICE Guideline NG59; Eklund et al. (2018) Nordic Maintenance Care RCT; Senna & Machaly (2011) Spine; Cochrane Review CD008112 (Rubinstein et al.).",
    "encourageWellness": "Мы рекомендуем регулярные осмотры даже после исчезновения симптомов. Здоровье вашего опорно-двигательного аппарата — это непрерывный путь, и мы готовы поддержать вас на каждом этапе.",
    "versionHistory": "История изменений",
    "supersededBanner": "Вы просматриваете устаревшую версию. Она доступна только для чтения.",
    "versionLabel": "Версия",
    "versionCurrent": "текущая",
    "versionSuperseded": "заменена",
    "notReadyTitle": "Этот отчёт ещё не готов",
    "notReadyBody": "В оценке пока недостаточно записанных данных для формирования отчёта пациента. Завершите оставшиеся шаги и откройте отчёт снова."
  },
  "soap": {
    "title": "SOAP заметка",
    "printView": "SOAP заметка — Печать",
    "loading": "Загрузка SOAP заметки...",
    "autoGenerate": "Автогенерация",
    "aiPolish": "ИИ улучшение",
    "aiPolishing": "ИИ улучшение...",
    "backToEditor": "Назад к редактору",
    "saveNote": "Сохранить SOAP заметку",
    "saving": "Сохранение...",
    "savedSuccess": "SOAP заметка сохранена успешно.",
    "autoGenerated": "Заметка автоматически создана из данных обследования.",
    "subjective": "Субъективные данные",
    "objective": "Объективно (Результаты и Рабочие Гипотезы)",
    "assessment": "Действие / Лечение",
    "plan": "План",
    "subjectivePlaceholder": "Жалобы, анамнез и симптомы пациента...",
    "objectivePlaceholder": "Данные осмотра, рабочие гипотезы DDx, оценка BPS...",
    "assessmentPlaceholder": "напр., МТ C4-5 R ротация, моб. IV ст. L4-5, МТТ верх. трапеции Б...",
    "planPlaceholder": "План лечения, наблюдение, направления, обучение пациента...",
    "formatting": "Форматирование:",
    "errors": {
      "generateFailed": "Ошибка создания SOAP заметки",
      "saveFailed": "Ошибка сохранения SOAP заметки"
    }
  },
  "settings": {
    "title": "Настройки клиники",
    "manageDesc": "Управление брендингом и информацией о клинике",
    "viewDesc": "Просмотр информации о клинике",
    "clinicInfo": "Информация о клинике",
    "clinicName": "Название клиники",
    "phone": "Телефон",
    "email": "Email",
    "website": "Сайт",
    "address": "Адрес",
    "instagram": "Instagram",
    "openingHours": "Часы работы",
    "clinicLogo": "Логотип клиники",
    "logoDesc": "Загрузите логотип клиники. Он будет отображаться в заголовке приложения, странице входа и отчётах. Форматы: PNG, JPG, SVG. Макс. 2МБ.",
    "uploading": "Загрузка…",
    "uploadLogo": "Загрузить логотип",
    "removeLogo": "Удалить логотип",
    "branding": "Брендинг",
    "primaryColor": "Основной цвет",
    "usedInHeaders": "Используется в заголовках отчётов",
    "reportFooter": "Текст подвала отчёта",
    "qrCodeUrl": "URL QR-кода (для отчётов)",
    "qrCodeDesc": "Вставьте ссылку для записи, страницу Instagram или ссылку Google Maps. QR-код появится в отчётах пациентов.",
    "saveClinicInfo": "Сохранить информацию о клинике",
    "aiConfig": "Настройка ИИ",
    "aiConfigDesc": "Настройте внешнее ИИ API для клинического анализа: второе мнение ДДх, создание SOAP заметок и анализ изображений.",
    "aiProvider": "Поставщик ИИ",
    "model": "Модель",
    "enterModel": "Введите название модели",
    "apiKey": "Ключ API",
    "currentKeyMasked": "Текущий ключ: [скрыт] — оставьте пустым для сохранения",
    "apiEndpoint": "Конечная точка API",
    "monthlyBudget": "Месячный лимит бюджета (необязательно)",
    "noLimit": "Без ограничений",
    "perMonth": "/ мес. (информационно)",
    "saveAiConfig": "Сохранить настройку ИИ",
    "testConnection": "Тест соединения",
    "testing": "Тестирование…",
    "emailConfig": "Настройка Email (SMTP)",
    "emailConfigDesc": "Настройте SMTP для отправки отчётов пациентам по email. Пароль SMTP хранится зашифрованным.",
    "enableEmail": "Включить отправку email",
    "smtpHost": "SMTP сервер",
    "smtpPort": "SMTP порт",
    "smtpPortWarning465": "Порт 465 может быть заблокирован некоторыми хостинг-провайдерами. Если письма не отправляются, переключитесь на порт 587 (STARTTLS).",
    "smtpUser": "SMTP пользователь",
    "smtpPassword": "SMTP пароль",
    "smtpFrom": "Email отправителя",
    "saveSmtpConfig": "Сохранить настройку SMTP",
    "tabClinicSettings": "Настройки клиники",
    "tabTreatmentProtocols": "Протоколы лечения",
    "navIdentity": "Идентичность клиники",
    "navTeam": "Ваша команда",
    "navModalities": "Методы лечения",
    "navTools": "Инструменты оценки",
    "navPathway": "Путь лечения",
    "navReports": "Отчёты",
    "navChecker": "Проверка симптомов",
    "navIntegrations": "Интеграции",
    "navType": "Тип клиники",
    "navBilling": "Счета",
    "whatsappNumber": "Номер WhatsApp",
    "googleMapsLink": "Ссылка Google Maps",
    "facebook": "Facebook",
    "linkedin": "LinkedIn",
    "regionalSettings": "Региональные настройки",
    "dateFormat": "Формат даты",
    "dateFmtEU": "ДД/ММ/ГГГГ (ЕС/Кипр)",
    "dateFmtUS": "ММ/ДД/ГГГГ (США)",
    "dateFmtISO": "ГГГГ-ММ-ДД (ISO)",
    "measurementSystem": "Система измерений",
    "measureMetric": "Метрическая (см, кг)",
    "measureImperial": "Имперская (дюймы, фунты)",
    "customNextSteps": "Настройка следующих шагов",
    "customNextStepsDesc": "Настройте раздел \"Следующие шаги\" в отчётах пациентов собственным сообщением и изображением.",
    "customMessage": "Пользовательское сообщение",
    "generateWithAi": "Сгенерировать с AI",
    "nextStepsImage": "Изображение следующих шагов (необязательно)",
    "nextStepsImageDesc": "Загрузите изображение для отображения в разделе Следующих Шагов отчётов. Макс. 1 МБ.",
    "removeImage": "Удалить изображение",
    "reportContent": "Содержание отчёта",
    "reportContentDesc": "Настройте текст в разделах отчёта пациента.",
    "aboutOurTeam": "О нашей команде",
    "treatmentApproach": "Подход к лечению",
    "maintenanceWellnessMsg": "Сообщение о поддерживающем уходе",
    "yourTeam": "Ваша команда",
    "addMember": "+ Добавить члена",
    "teamDesc": "Эти члены команды отображаются в Отчёте Пациента в разделе \"Ваша команда\". Ведущий врач подписывает отчёты.",
    "fullName": "Полное имя *",
    "roleTitle": "Должность / Роль в клинике *",
    "professionalCredential": "Профессиональная квалификация",
    "selectCredential": "— Выберите квалификацию —",
    "displayOnReports": "Отображение в отчётах",
    "displayPrefNameCred": "Имя (Квалификация) — по умолчанию",
    "displayPrefNameOnly": "Только имя",
    "displayPrefCustom": "Произвольный — свободный текст",
    "customTitlePlaceholder": "Как именно вы хотите, чтобы ваше имя отображалось в отчётах",
    "preview": "Предпросмотр:",
    "shortBio": "Краткое резюме",
    "shortBioPlaceholder": "Краткая профессиональная биография в отчётах (макс. 600 символов)",
    "leadClinician": "Ведущий / Владелец клиники",
    "leadClinicianNote": "(подписывает отчёты, только один на клинику)",
    "lead": "Ведущий",
    "noTeamMembers": "Члены команды не настроены. Нажмите \"Добавить члена\", чтобы начать.",
    "saveModalities": "Сохранить методы лечения",
    "saveAllChanges": "",
    "saveAssessmentTools": "Сохранить инструменты оценки",
    "saveCarePathway": "Сохранить путь лечения",
    "saveReportPreferences": "Сохранить настройки отчётов",
    "reportTemplates": "Шаблоны отчётов",
    "reportTemplatesDesc": "Разработайте и настройте макет отчётов пациентов.",
    "aiCredits": "Кредиты AI",
    "mskCredits": "Кредиты MSK",
    "ownApiKey": "Свой ключ API",
    "aiCreditsDesc": "Выберите, как работают функции AI.",
    "aiMode": "Режим AI",
    "useOwnApiKey": "Использовать свой ключ API",
    "useMskCredits": "Использовать кредиты MSK Insight AI",
    "creditBalance": "Баланс кредитов",
    "creditRateFast": "Быстрый вызов = 1 кредит",
    "creditRateSmart": "Умный вызов = 5 кредитов",
    "creditRateFormat": "Вызов форматирования = 1 кредит",
    "lowCreditsWarning": "Мало кредитов! Функции AI могут вскоре прекратить работу. Приобретите больше кредитов.",
    "creditPacks": "Пакеты кредитов",
    "buyCredits": "Купить кредиты",
    "buyCreditsNote": "Свяжитесь с support@mskinsight.com для покупки",
    "googleReviews": "Отзывы Google",
    "connected": "Подключено",
    "notConnected": "Не подключено",
    "googleReviewsDesc": "Подключите ссылку Google Business для отправки запросов отзывов пациентам по email или WhatsApp.",
    "googleReviewUrlLabel": "URL отзыва Google",
    "googleReviewUrlHint": "Найдите ссылку в Google Business Profile в разделе \"Получить больше отзывов\"",
    "saveReviewUrl": "Сохранить URL отзыва",
    "whatsappBusiness": "WhatsApp Business",
    "notConfigured": "Не настроено",
    "whatsappBusinessDesc": "Настройте номер WhatsApp Business и шаблон сообщения для связи с пациентами.",
    "whatsappBusinessNumber": "Номер WhatsApp Business",
    "whatsappNumberHint": "Включите код страны (например, +357 для Кипра, +44 для Великобритании)",
    "defaultMsgTemplate": "Шаблон сообщения по умолчанию",
    "templateVariables": "Доступные переменные: {patientName}, {clinicName}, {condition}, {reviewUrl}",
    "saveWhatsappSettings": "Сохранить настройки WhatsApp",
    "testWhatsapp": "Тест WhatsApp",
    "saveClinicType": "Сохранить тип клиники",
    "demoMode": "Демо-режим",
    "demoModeDesc": "Загрузить демо-данные. Реальные данные пациентов не будут видны.",
    "demoModeOn": "Демо-режим ВКЛЮЧЁН — реальные данные пациентов скрыты",
    "modalities": {
      "_TRANSLATE_ME": "Night 10 stub. All strings below are empty — i18next falls back to EN until translated. See ~/Desktop/MODALITIES-DECISIONS-LOCKED.md.",
      "title": "",
      "helperText": "",
      "clinicNotesHint": "",
      "clinicNotesPlaceholder": "",
      "customGroupLabel": "",
      "removeCustom": "",
      "addCustomTitle": "",
      "addCustomPlaceholder": "",
      "addCustomButton": "",
      "filledSummary": "",
      "groups": {
        "manual": {
          "label": ""
        },
        "active": {
          "label": ""
        },
        "modality_based": {
          "label": ""
        },
        "education": {
          "label": ""
        }
      },
      "items": {
        "spinal_manipulation": {
          "label": "",
          "description": ""
        },
        "instrument_adjusting": {
          "label": "",
          "description": ""
        },
        "drop_piece": {
          "label": "",
          "description": ""
        },
        "soft_tissue": {
          "label": "",
          "description": ""
        },
        "iastm": {
          "label": "",
          "description": ""
        },
        "dry_needling": {
          "label": "",
          "description": ""
        },
        "cupping": {
          "label": "",
          "description": ""
        },
        "neural_mobilisation": {
          "label": "",
          "description": ""
        },
        "joint_mobilisation": {
          "label": "",
          "description": ""
        },
        "rehab_exercises": {
          "label": "",
          "description": ""
        },
        "functional_movement": {
          "label": "",
          "description": ""
        },
        "clinical_pilates": {
          "label": "",
          "description": ""
        },
        "gait_retraining": {
          "label": "",
          "description": ""
        },
        "neuromuscular_reeducation": {
          "label": "",
          "description": ""
        },
        "breathing_exercises": {
          "label": "",
          "description": ""
        },
        "spinal_decompression": {
          "label": "",
          "description": ""
        },
        "shockwave": {
          "label": "",
          "description": ""
        },
        "laser": {
          "label": "",
          "description": ""
        },
        "tens": {
          "label": "",
          "description": ""
        },
        "ultrasound": {
          "label": "",
          "description": ""
        },
        "kinesio_taping": {
          "label": "",
          "description": ""
        },
        "rigid_taping": {
          "label": "",
          "description": ""
        },
        "normatec": {
          "label": "",
          "description": ""
        },
        "heat_therapy": {
          "label": "",
          "description": ""
        },
        "hydrotherapy": {
          "label": "",
          "description": ""
        },
        "red_light_therapy": {
          "label": "",
          "description": ""
        },
        "posture_analysis": {
          "label": "",
          "description": ""
        },
        "patient_education": {
          "label": "",
          "description": ""
        },
        "ergonomic_assessment": {
          "label": "",
          "description": ""
        },
        "nutritional": {
          "label": "",
          "description": ""
        }
      },
      "primaryDiscipline": {
        "title": "",
        "helperText": "",
        "options": {
          "chiropractic": {
            "label": "",
            "description": ""
          },
          "physiotherapy": {
            "label": "",
            "description": ""
          },
          "osteopathy": {
            "label": "",
            "description": ""
          },
          "sports_medicine": {
            "label": "",
            "description": ""
          },
          "multidisciplinary": {
            "label": "",
            "description": ""
          }
        }
      }
    },
    "_TRANSLATE_ME_NIGHT_12B": "Night 12b stub. Values marked '[_TRANSLATE_ME]' fall back to EN at render time. See proof/night12b/USER-EVIDENCE.md.",
    "navDiagnosticEquipment": "Диагностическое оборудование",
    "navOutcomeMeasuresAndTests": "Меры исхода и тесты",
    "diagnosticEquipment": {
      "title": "Диагностическое оборудование",
      "subtitle": "Выберите диагностические инструменты и инструменты оценки, доступные в вашей клинике."
    },
    "outcomeMeasuresAndTests": {
      "title": "Меры исхода и тесты",
      "helperText": "Выберите, какие меры исхода со слов пациента и какие наборы ортопедических тестов использует ваша клиника. Подсказки ИИ и рабочие процессы оценки будут согласованы с этим выбором."
    },
    "outcomeMeasures": {
      "sectionTitle": "Меры исхода",
      "sectionSubtitle": "12 валидированных инструментов со слов пациента. Отключённые меры не будут предлагаться в процессе оценки.",
      "filledSummary": "{{count}} из {{total}} мер исхода включено",
      "groups": {
        "generic": {
          "label": "Общие"
        },
        "region_specific": {
          "label": "По регионам"
        },
        "psychosocial": {
          "label": "Психосоциальный скрининг"
        }
      },
      "items": {
        "PSFS": {
          "label": "Patient-Specific Functional Scale",
          "description": "Пациент определяет 3-5 активностей, ограниченных его состоянием; оценивает способность 0-10."
        },
        "NPRS": {
          "label": "Numeric Pain Rating Scale",
          "description": "Одношкальная оценка боли 0-10. Быстро, универсально понятно."
        },
        "VAS": {
          "label": "Visual Analog Scale",
          "description": "Непрерывная шкала 0-100мм для боли или других субъективных мер."
        },
        "GROC": {
          "label": "Global Rating of Change",
          "description": "Единая ретроспективная оценка общего изменения от исходного состояния от -7 до +7."
        },
        "NDI": {
          "label": "Neck Disability Index",
          "description": "Индекс инвалидности из 10 пунктов для шейных состояний. Балл 0-50."
        },
        "ODI": {
          "label": "Oswestry Disability Index",
          "description": "Индекс инвалидности из 10 пунктов для боли в пояснице. Балл 0-100; MCID ~10."
        },
        "DASH": {
          "label": "DASH — Инвалидность Верхней Конечности",
          "description": "Disabilities of the Arm, Shoulder and Hand. Шкала из 30 пунктов."
        },
        "LEFS": {
          "label": "Lower Extremity Functional Scale",
          "description": "Функциональная оценка из 20 пунктов для скелетно-мышечных состояний нижних конечностей."
        },
        "PHQ9": {
          "label": "Patient Health Questionnaire-9",
          "description": "Скрининг тяжести депрессии. Балл 0-27."
        },
        "GAD7": {
          "label": "Generalised Anxiety Disorder-7",
          "description": "Скрининг тяжести тревоги. Балл 0-21."
        },
        "STarT_Back": {
          "label": "STarT Back Screening Tool",
          "description": "Стратификация риска боли в спине из 9 пунктов (низкий / средний / высокий риск)."
        },
        "TSK11": {
          "label": "Tampa Scale Kinesiophobia-11",
          "description": "Шкала страха движения из 11 пунктов. Балл 11-44."
        }
      }
    },
    "orthopaedicTestPacks": {
      "sectionTitle": "Наборы Ортопедических Тестов",
      "sectionSubtitle": "14 наборов тестов, сгруппированных по областям. Каждый набор активирует подборку ортопедических тестов в процессе оценки.",
      "testCount": "{{count}} тестов",
      "filledSummary": "{{count}} из {{total}} наборов включено ({{tests}} тестов доступно)",
      "groups": {
        "axial": {
          "label": "Осевая"
        },
        "upper_extremity": {
          "label": "Верхняя конечность"
        },
        "lower_extremity": {
          "label": "Нижняя конечность"
        },
        "special": {
          "label": "Особые"
        }
      },
      "items": {
        "CERVICAL": {
          "label": "Шейный отдел",
          "description": "Spurling, distraction, ULTT, скрининг позвоночной артерии и ещё 11."
        },
        "THORACIC": {
          "label": "Грудной отдел",
          "description": "Spring testing, Adam forward bend, тесты рёберно-позвоночных суставов."
        },
        "LUMBAR": {
          "label": "Поясничный отдел",
          "description": "SLR, slump, prone instability, Kemp и ещё 16."
        },
        "SI_JOINT": {
          "label": "Крестцово-Подвздошный",
          "description": "Кластер из 5 провокационных тестов КПС (distraction, compression, thigh thrust, Gaenslen, sacral thrust)."
        },
        "SACRAL": {
          "label": "Крестец",
          "description": "Пальпация движения крестца, провокация крестцово-копчикового сустава, подвижность копчика."
        },
        "HEADACHE": {
          "label": "Головная боль",
          "description": "Провокационные тесты цервикогенной и тензионной головной боли."
        },
        "SHOULDER": {
          "label": "Плечо",
          "description": "Neer, Hawkins-Kennedy, Empty Can, O Brien, apprehension и ещё 15."
        },
        "ELBOW": {
          "label": "Локоть",
          "description": "Cozen, Mill, тесты стресса связок, Tinel и другие."
        },
        "WRIST_HAND": {
          "label": "Запястье / Кисть",
          "description": "Phalen, Tinel на запястье, Finkelstein, тесты ладьевидной кости и другие."
        },
        "HIP": {
          "label": "Тазобедренный",
          "description": "FABER, FADIR, Trendelenburg, тест Thomas и ещё 8."
        },
        "KNEE": {
          "label": "Колено",
          "description": "Lachman, anterior drawer, McMurray, valgus/varus stress и ещё 15."
        },
        "ANKLE_FOOT": {
          "label": "Голеностоп / Стопа",
          "description": "Anterior drawer, talar tilt, Thompson, тесты синдесмоза и другие."
        },
        "DIZZINESS": {
          "label": "Головокружение",
          "description": "Dix-Hallpike, вестибулярно-окулярный моторный скрининг (VOMS), шейный скрининг."
        },
        "PAEDIATRIC": {
          "label": "Педиатрия",
          "description": "26 специальных педиатрических скринингов, охватывающих походку, осанку, гипермобильность суставов и этапы развития."
        }
      }
    },
    "carePathway": {
      "title": "Настройки Пути Лечения",
      "description": "Настройте фазы лечения с диапазонами частоты и длительности, пресетами тяжести и правилами повторного осмотра.",
      "phaseHeading": "Фаза",
      "phaseName": "Название Фазы",
      "subtitle": "Подзаголовок",
      "frequency": "Частота",
      "frequencyTo": "до",
      "visitsPer": "визитов в",
      "duration": "Длительность",
      "weeks": "недель",
      "ongoing": "Постоянно",
      "frequencyBlocks": "Блоки Частоты",
      "frequencyBlocksHint": "(необязательно — используется для составления расписания визитов)",
      "blockThen": "затем",
      "blockFor": "в течение",
      "addFrequencyBlock": "+ Добавить блок частоты",
      "goals": "Цели",
      "goalPlaceholder": "Введите цель...",
      "addGoal": "+ Добавить цель",
      "patientMessage": "Сообщение Пациенту",
      "patientMessagePlaceholder": "Сообщение, которое видят пациенты в отчётах...",
      "remove": "Удалить",
      "addPhase": "+ Добавить Фазу",
      "severityPresets": "Пресеты Тяжести",
      "severityMild": "Лёгкая",
      "severityModerate": "Умеренная",
      "severitySevere": "Тяжёлая",
      "severityFor": "в течение",
      "severityWk": "нед",
      "reExamRules": "Правила Повторного Осмотра",
      "firstReExamAfter": "Первый повторный осмотр после",
      "thenEvery": "Затем каждые",
      "visits": "визитов",
      "customRule": "Особое Правило (необязательно)",
      "customRulePlaceholder": "напр., Всегда повторный осмотр после школьных каникул",
      "terminology": "Предпочтение Терминологии",
      "wellnessCare": "Поддержание Здоровья",
      "maintenanceCare": "Поддерживающая Терапия",
      "livePreview": "Живой Просмотр",
      "previewLabel": "Просмотр",
      "reExam": "Повторный осмотр:",
      "reExamSentence": "Мы оценим ваш прогресс после {{firstMin}}-{{firstMax}} визитов, затем каждые {{recMin}}-{{recMax}} визитов.",
      "periodWeek": "неделю",
      "periodFortnight": "две недели",
      "periodMonth": "месяц"
    },
    "checker": {
      "sectionTitle": "Чек-лист Симптомов",
      "sectionDescription": "Ваша публичная страница проверки симптомов для пациентов и рекламных кампаний.",
      "statusLive": "АКТИВНО",
      "statusNotActivated": "Не Активировано",
      "preview": "Предпросмотр",
      "copy": "Копировать",
      "copied": "Скопировано!",
      "adCampaignTitle": "URL Рекламной Кампании",
      "adCampaignDescription": "Используйте эти URL в рекламе на Facebook, Google и Instagram, чтобы направить пациентов к чек-листу симптомов с нужным языком и областью тела.",
      "enableAtLeastOne": "Включите хотя бы один язык в Настройках Чек-листа ниже.",
      "baseUrl": "Базовый URL",
      "copyAll": "Копировать Все",
      "regionLumbar": "Боль в Спине",
      "regionCervical": "Боль в Шее",
      "regionShoulder": "Плечо",
      "regionKnee": "Колено",
      "customisationTitle": "Настройка Чек-листа",
      "customisationDescription": "Настройте языки, параметры отображения и отслеживание для чек-листа симптомов.",
      "languages": "Языки",
      "defaultLanguage": "Язык по Умолчанию",
      "displayOptions": "Параметры Отображения",
      "showConfidence": "Показывать оценку уверенности",
      "showClinicalTerms": "Показывать клинические термины",
      "showShareButton": "Показывать кнопку «Поделиться»",
      "showDisclaimer": "Показывать предупреждение",
      "customDisclaimer": "Своё Предупреждение",
      "customDisclaimerPlaceholder": "Оставьте пустым для использования стандартного предупреждения",
      "whatsappTemplate": "Шаблон Сообщения WhatsApp",
      "whatsappTemplateHint": "Используйте {{conditionPh}} и {{regionPh}} как заполнители.",
      "gaId": "ID Google Analytics",
      "fbPixelId": "ID Facebook Pixel",
      "bookingButtonsTitle": "Кнопки Записи",
      "bookingButtonsDescription": "Выберите, какие кнопки контакта будут отображаться на странице результатов чек-листа.",
      "showBookOnline": "Показывать кнопку «Записаться Онлайн»",
      "showBookOnlineNoUrl": "Показывать кнопку «Записаться Онлайн» (URL записи не задан)",
      "showWhatsapp": "Показывать кнопку «WhatsApp»",
      "showWhatsappNoNumber": "Показывать кнопку «WhatsApp» (номер WhatsApp не задан)",
      "showCall": "Показывать кнопку «Позвонить»",
      "showCallNoPhone": "Показывать кнопку «Позвонить» (номер телефона не задан)",
      "usageTitle": "Использование",
      "usageLoading": "Загрузка данных использования...",
      "usageUnableToLoad": "Не удалось загрузить данные использования.",
      "usageChecksThisMonth": "проверок в этом месяце",
      "usageUnlimited": "(Без ограничений)",
      "saveButton": "Сохранить Настройки Чек-листа",
      "saving": "Сохранение..."
    },
    "reportPreferences": {
      "title": "Настройки Отчётов и Писем Терапевту",
      "description": "Настройте содержание отчётов, языки и форматирование писем терапевту.",
      "reportLanguages": "Языки Отчётов",
      "defaultReportLanguage": "Язык Отчёта по Умолчанию",
      "reportContentHeading": "Содержание Отчёта Пациента",
      "includeTeam": "Включить раздел о команде",
      "includeStatistics": "Включить раздел статистики/исследований",
      "includeSupplements": "Включить раздел добавок",
      "includeExercises": "Включить программу упражнений",
      "commonReferralSpecialists": "Частые Направляющие Специалисты (один на строку)",
      "commonReferralSpecialistsPlaceholder": "Ортопед-хирург\nНевролог\nРевматолог"
    },
    "navAuditLog": "Журнал аудита",
    "navPrivacy": "Данные и конфиденциальность",
    "navSecurity": "Безопасность",
    "frontDeskModule": "Регистратура",
    "frontDeskModuleDesc": "Сверка блочных записей, очереди перезаписи и неявок, подтверждения и передача смены. Синхронизация приёмов продолжается независимо от этой настройки.",
    "practiceHub": "PracticeHub",
    "practiceHubDesc": "Синхронизация пациентов и управление документами. Записи и карты пациентов загружаются из вашей учётной записи PracticeHub.",
    "enablePracticeHub": "Включить синхронизацию PracticeHub",
    "phBaseUrl": "Базовый URL PracticeHub",
    "phApiKey": "Ключ API",
    "phApiKeyPlaceholder": "Введите ключ API",
    "phApiKeyFingerprint": "Отпечаток ключа: {{fp}} — оставьте пустым, чтобы сохранить",
    "phApiKeyIsV3": "Это ключ нового API (phk_). MSK Insight пока не использует такие ключи; сохраните его для будущего подключения v3.",
    "phSavedKeyAccepted": "Сохранено — PracticeHub принял ключ (видно карт пациентов: {{patients}}).",
    "phSavedKeyRefused": "Сохранено, но PracticeHub отклонил ключ. Проверьте, что вы скопировали ключ из PracticeHub полностью.",
    "phSavedKeyRateLimited": "Сохранено, но PracticeHub сейчас ограничивает запросы. Нажмите «Проверить подключение» через несколько минут.",
    "phSavedKeyUntested": "Сохранено, но не удалось связаться с PracticeHub для проверки. Нажмите «Проверить подключение».",
    "phAppDetails": "Сведения о приложении",
    "phAppDetailsHint": "Название приложения, которое PracticeHub показывает для этого подключения.",
    "savePracticeHubConfig": "Сохранить настройки PracticeHub",
    "phTestOk": "Подключено — видно карт пациентов: {{patients}}.",
    "phTestOkNoCount": "Подключено.",
    "phTestFailed": "Проверка подключения не удалась",
    "phSaved": "Настройки PracticeHub сохранены.",
    "phSaveFailed": "Не удалось сохранить настройки PracticeHub."
  },
  "audit": {
    "title": "Журнал аудита",
    "dateFrom": "Дата с",
    "dateTo": "Дата по",
    "user": "Пользователь",
    "searchByName": "Поиск по имени...",
    "action": "Действие",
    "entity": "Объект",
    "applyFilters": "Применить фильтры",
    "recordsFound": "{{count}} запись(-ей) найдено",
    "noEntries": "Записей журнала аудита не найдено по текущим фильтрам.",
    "table": {
      "timestamp": "Дата и время",
      "user": "Пользователь",
      "action": "Действие",
      "entity": "Объект",
      "details": "Подробности"
    },
    "page": "Страница {{current}} из {{total}}",
    "actions": {
      "all": "Все действия",
      "create": "Создание",
      "read": "Чтение",
      "update": "Обновление",
      "delete": "Удаление",
      "login": "Вход",
      "logout": "Выход",
      "export": "Экспорт",
      "consent": "Согласие"
    },
    "entities": {
      "all": "Все объекты",
      "patient": "Пациент",
      "assessment": "Обследование",
      "user": "Пользователь",
      "consent": "Согласие",
      "report": "Отчёт",
      "referral": "Направление"
    }
  },
  "gdpr": {
    "title": "GDPR и конфиденциальность данных",
    "description": "Управление правами данных пациентов включая экспорт, удаление и анонимизацию в соответствии с GDPR.",
    "findPatient": "Найти пациента",
    "searchPlaceholder": "Поиск по имени, email или ID пациента...",
    "searching": "Поиск...",
    "selectedPatient": "Выбранный пациент",
    "dataExport": "Экспорт данных",
    "exportDesc": "Экспорт всех данных пациента в файл JSON. Включает личную информацию, обследования, согласия и клинические записи.",
    "exporting": "Экспорт...",
    "exportButton": "Экспорт данных пациента (JSON)",
    "rightToForget": "Право на забвение",
    "rightToForgetDesc": "Полное удаление всех данных пациента. Это действие необратимо и будет запланировано с льготным периодом.",
    "requestDeletion": "Запросить удаление данных",
    "typeDeleteConfirm": "Введите DELETE для подтверждения удаления:",
    "processing": "Обработка...",
    "confirmDelete": "Подтвердить удаление",
    "anonymization": "Анонимизация",
    "anonymizationDesc": "Удаление персональных идентификаторов с сохранением клинических данных для исследований и аналитики.",
    "anonymizeButton": "Анонимизировать данные пациента",
    "anonymizeWarning": "Все персональные идентификаторы будут удалены. Клинические данные сохранятся анонимно.",
    "confirmAnonymize": "Подтвердить анонимизацию",
    "consentOverview": "Обзор согласий на обработку данных",
    "noConsent": "Записей о согласии для этого пациента не найдено.",
    "consentTable": {
      "type": "Тип согласия",
      "status": "Статус",
      "lastUpdated": "Обновлено"
    }
  },
  "wizard": {
    "step": "Шаг",
    "of": "из",
    "saveAndExit": "Сохранить и выйти",
    "aiAnalysingImages": "ИИ анализирует {{count}} изображение",
    "stepNames": {
      "1": "Основные жалобы",
      "2": "Анамнез",
      "3": "Физический осмотр",
      "4": "Анализ осанки",
      "5": "Исследования",
      "6": "Показатели исхода",
      "7": "Обзор ДДх",
      "8": "План лечения",
      "9": "Создание отчёта"
    },
    "fullAssessment": "Полное обследование",
    "quickScore": "Быстрая оценка",
    "reExamination": "Повторное обследование",
    "stepOf": "Шаг {{current}} из {{total}}",
    "paediatric": "Педиатрический",
    "finalized": "Завершено",
    "savedAt": "Сохранено {{time}}",
    "saveAndContinueTo": "Сохранить и перейти к {{stepName}} →",
    "saveAndContinue": "Сохранить и продолжить →",
    "previousSection": "← Предыдущий раздел",
    "completeAssessment": "✓ Завершить обследование",
    "optional": "Необязательно",
    "loadingAssessment": "Загрузка обследования…",
    "goBack": "Вернуться",
    "noPatientSelected": "Пациент не выбран. Начните обследование из профиля пациента.",
    "viewPatients": "Просмотр пациентов",
    "saveAsDraft": "💾 Сохранить как черновик — регистратура завершит",
    "continueToReport": "Перейти к созданию отчёта →",
    "finalizeReport": "Завершить отчёт",
    "finalizeReady": "Когда все разделы готовы, завершите отчёт.",
    "reportFinalized": "Отчёт завершён и готов для пациента.",
    "stepComingSoon": "Шаг {{step}} — содержимое скоро появится.",
    "saveDraft": "Сохранить Черновик",
    "validation": {
      "complaintsRequired": "Пожалуйста, добавьте хотя бы одну жалобу перед продолжением."
    },
    "finalizeErrorTitle": "Оформление не завершено.",
    "finalizeAlreadyIssued": "Этот отчёт уже выдан. Откройте его для внесения поправки, чтобы опубликовать новую версию.",
    "finalizeNotAuthor": "Вносить поправки может только врач, выдавший этот отчёт.",
    "finalizeFailed": "Ничего не сохранено. Пожалуйста, попробуйте ещё раз.",
    "noFrequency": {
      "title": "Частота лечения не задана",
      "body": "В этом плане нет блоков частоты лечения, поэтому в отчёте не будет графика визитов.",
      "applyDefault": "Применить {{preset}} и завершить",
      "completeAnyway": "Завершить без плана частоты",
      "presetMissing": "Не удалось загрузить пресет по умолчанию — задайте частоту на шаге «План ведения».",
      "lowVisitsTitle": "Активных посещений в плане: {{count}}. Всё равно выпустить отчёт?",
      "lowVisitsBody": "Такой короткий план не является курсом лечения, поэтому в отчёте не будет указан расчётный срок завершения. Можно сначала применить шаблон или выпустить отчёт как есть.",
      "noPresetTitle": "К этому плану не применён шаблон. Всё равно выпустить отчёт?",
      "noPresetBody": "Без шаблона в отчёте не будет указан расчётный срок завершения. Можно сначала применить шаблон клиники по умолчанию или выпустить отчёт как есть.",
      "issueAnyway": "Всё равно выпустить"
    }
  },
  "patientReport": {
    "dear": "Уважаемый(ая)",
    "introP1": "Благодарим вас за то, что выбрали {{clinicName}} для заботы о вашем здоровье. По результатам проведённого обследования мы рады представить вам персональный отчёт. В нём описано, что мы обнаружили, как мы планируем вам помочь и что вы можете делать дома для поддержки восстановления. Мы хотим, чтобы вы чувствовали уверенность и были информированы на каждом этапе.",
    "introP2": "Наша цель — не только помочь вам почувствовать себя лучше, но и помочь вам сохранить это состояние. Мы рядом, чтобы поддерживать вас на каждом этапе лечения.",
    "whatWeFound": "Что мы обнаружили",
    "aiSummaryTitle": "Итоги вашего визита",
    "whatWeFoundIntro": "На основании Вашего анамнеза и обследования полученные данные в наибольшей степени соответствуют следующим рабочим гипотезам. Они описывают паттерны, которые могут способствовать Вашим симптомам; они не подтверждают одну конкретную структуру как точный источник боли и могут быть пересмотрены по мере наблюдения за Вашим прогрессом или получения новой информации. План помощи определяется Вашими симптомами, функцией, результатами обследования, целями и реакцией на помощь, а не только названием состояния. При необходимости мы также порекомендуем медицинскую оценку или дополнительное обследование.",
    "whatIsIt": "Что это?",
    "howDoesItHappen": "Как это возникает?",
    "whatCanBeDone": "Что можно сделать?",
    "whatToExpect": "Чего ожидать?",
    "whatDoesThisMean": "Что это значит?",
    "reExamDisclaimer": "Исследования указывают на типичные сроки восстановления и частоту лечения для этих состояний. Мы предпочитаем действовать по предложенному плану и пересматривать ваш прогресс по ходу дела. Эти повторные осмотры помогают нам сравнить, какими вы были, какими вы сейчас, и решить, как будем продолжать вместе.",
    "yourProgress": "Ваш прогресс",
    "yourTreatmentPlan": "Ваш план лечения",
    "treatmentPlanIntro": "Ваше лечение состоит из нескольких фаз, каждая из которых строится на результатах предыдущей. Представьте это как путь от облегчения боли через реабилитацию к долгосрочному оздоровлению.",
    "expectedDuration": "Ожидаемая продолжительность",
    "treatmentsConcurrent": "(лечение всех состояний проводится параллельно)",
    "phase": "Фаза",
    "duration": "Продолжительность",
    "weeks": "недель",
    "frequency": "Частота",
    "phaseTableStage": "Этап лечения",
    "phaseTableCondition": "Состояние",
    "phaseTableFocus": "Фокус",
    "phaseTableCadenceNote": "Частота визитов указана в расписании частоты лечения ниже.",
    "techniques": "Методы",
    "goals": "Цели",
    "goldenRulesTitle": "Ваши золотые правила",
    "goldenRulesIntro": "Это ключевые рекомендации, которые важно помнить между приёмами. Соблюдение этих правил поможет вам получить максимальный результат от лечения.",
    "doNow": "Что делать сейчас",
    "thingsToAvoid": "Чего следует избегать",
    "lifestyleChanges": "Изменения образа жизни",
    "homeCareTitle": "Рекомендации по уходу дома",
    "supplementsTitle": "Рекомендуемые добавки",
    "supplementsIntro": "Эти добавки рекомендованы на основе вашего обследования для поддержки восстановления. Всегда консультируйтесь со своим врачом или фармацевтом перед началом приёма новых добавок, особенно если вы принимаете лекарства.",
    "supplement": "Добавка",
    "yourWellnessScore": "Ваш показатель физической формы",
    "wellnessScoreIntro": "Ваш показатель физической формы отражает различные аспекты состояния вашей костно-мышечной системы. Диаграмма ниже показывает, как обстоят дела в каждой области — мы будем отслеживать улучшения со временем.",
    "overallScore": "Общий показатель",
    "scoreExcellent": "Отлично — продолжайте в том же духе!",
    "scoreGood": "Хорошо — с целенаправленным лечением вы сможете достичь наилучших результатов.",
    "scoreFair": "Удовлетворительно — есть возможности для улучшения, и наш план направлен именно на это.",
    "scoreNeedsAttention": "Требует внимания — наш план лечения нацелен на области, которые нуждаются в наибольшей помощи.",
    "exercisesTitle": "Рекомендуемые упражнения",
    "exerciseSets": "подходов",
    "exerciseReps": "повторений",
    "exerciseHold": "удержание",
    "exerciseSec": "сек",
    "whyOngoingCare": "Почему важно продолжать лечение",
    "ongoingCareP1": "Исследования неизменно показывают, что пациенты, прошедшие полный курс лечения, включая фазу оздоровления, достигают значительно лучших долгосрочных результатов. Прекратить лечение, когда боль утихла, — всё равно что прекратить приём антибиотиков на полпути: симптомы могут исчезнуть, но основная проблема до конца не решена.",
    "ongoingCareP2": "Ваш путь лечения:",
    "carePhase1": "Терапия Облегчения — снижение боли и воспаления",
    "carePhase2": "Реабилитация — восстановление силы и функций",
    "carePhase3": "Поддерживающая забота — Поддержка долгосрочного движения, функции и самостоятельного ведения",
    "ongoingCareP3": "Пациенты, завершившие все фазы лечения, включая оздоровительную, реже сталкиваются с повторным возникновением проблемы. Мы настоятельно рекомендуем пройти все этапы лечения.",
    "yourCareTeam": "Ваша команда специалистов",
    "careTeamIntro": "Вы в надёжных руках. Наша команда опытных специалистов стремится помочь вам достичь наилучшего результата.",
    "nextSteps": "Следующие шаги",
    "nextStepsIntro": "Готовы начать путь к лучшему здоровью? Запишитесь на следующий приём уже сегодня.",
    "phone": "Телефон",
    "email": "Email",
    "website": "Сайт",
    "instagram": "Instagram",
    "footer": "Данный отчёт предоставлен в информационных целях в рамках вашего плана лечения. Перечисленные состояния являются рабочими гипотезами, предназначенными исключительно для клинического рассмотрения, и не являются окончательными диагнозами. Пожалуйста, обсудите любые вопросы с вашим лечащим врачом.",
    "footerOneLine": "Информационная сводка — перечисленные состояния являются рабочими гипотезами для клинического рассмотрения, а не окончательными диагнозами. Обсудите любые вопросы с вашим врачом.",
    "cta": {
      "whatsappLabel": "WhatsApp",
      "whatsappPrefix": "Напишите нам в WhatsApp:",
      "referTitle": "Порекомендуйте нас другу",
      "referHeading": "Знаете кого-то, кому могла бы помочь наша забота?",
      "referLine1": "Мы будем рады помочь и вашей семье и друзьям.",
      "referLine2": "Если вы знаете кого-то, кому это могло бы помочь, для нас будет честью принять их.",
      "referShare": "Поделитесь",
      "googleReviewCtaTitle": "Помогите другим найти нас",
      "googleReviewCtaBody": "Если мы вам помогли, пожалуйста, оставьте отзыв 5 звёзд в Google. Это занимает 30 секунд и помогает другим найти качественную помощь.",
      "googleReviewCtaButton": "Оставить отзыв в Google"
    }
  },
  "preview": {
    "tabs": {
      "clinician": "Клиницист",
      "patient": "Пациент"
    }
  },
  "redFlags": {
    "title": "Проверка красных флагов",
    "instructions": "Ответьте ДА или НЕТ на каждый вопрос. Вопросы задаются один раз для всего обследования.",
    "emergencyDetected": "ОБНАРУЖЕНА МЕДИЦИНСКАЯ ЭКСТРЕННАЯ СИТУАЦИЯ",
    "emergencyMessage": "Выявлена одна или несколько экстренных медицинских ситуаций. Немедленно проверьте и примите меры.",
    "flagsDetected": "Обнаружены красные флаги",
    "emergencyAndFlags": "Обнаружены экстренные ситуации и красные флаги",
    "emergencyInstruction": "СТОП: Экстренные флаги должны быть обработаны до начала клинических процедур. Все флаги требуют действий клинициста.",
    "flagsInstruction": "Следующие красные флаги требуют действий клинициста перед продолжением.",
    "screeningComplete": "Проверка красных флагов завершена. Проблем, требующих немедленных действий, не выявлено.",
    "backToReview": "← Назад к обзору жалоб",
    "reviewed": "Красные флаги проверены — используйте навигацию внизу для продолжения",
    "submitting": "Отправка...",
    "submitAndContinue": "Отправить проверку и продолжить →"
  },
  "statusBadges": {
    "draft": "Черновик",
    "in_progress": "В процессе",
    "clinician_draft": "Ожидает регистратуру",
    "front_desk_review": "Регистратура работает",
    "completed": "Завершено",
    "finalized": "Завершено окончательно"
  },
  "carePhases": {
    "initial": "Начальная",
    "active": "Активное лечение",
    "maintenance": "Поддерживающая",
    "wellness": "Оздоровление"
  },
  "bodyRegions": {
    "headache": "Головная боль",
    "dizziness": "Головокружение",
    "cervical": "Шейный",
    "thoracic": "Грудной",
    "lumbar": "Поясничный",
    "sacral": "Крестцовый",
    "shoulder_left": "Л. Плечо",
    "shoulder_right": "Пр. Плечо",
    "elbow_left": "Л. Локоть",
    "elbow_right": "Пр. Локоть",
    "wrist_hand_left": "Л. Запястье",
    "wrist_hand_right": "Пр. Запястье",
    "hip_left": "Л. Бедро",
    "hip_right": "Пр. Бедро",
    "knee_left": "Л. Колено",
    "knee_right": "Пр. Колено",
    "ankle_foot_left": "Л. Стопа",
    "ankle_foot_right": "Пр. Стопа",
    "tmj": "ВНЧС",
    "growing_pains": "Боли роста",
    "torticollis": "Кривошея"
  },
  "infant": {
    "reportTitle": "Отчёт о здоровье Вашего малыша",
    "progressUpdate": "Обновление прогресса",
    "initialAssessment": "Первичная оценка",
    "patientLabel": "Пациент",
    "ageLabel": "Возраст",
    "dateOfBirthLabel": "Дата рождения",
    "infantAssessment": "Оценка младенца",
    "loadingAssessment": "Загрузка оценки младенца...",
    "assessmentTitle": "Оценка младенца (0-12 месяцев)",
    "assessmentDescription": "Комплексный скрининг для младенцев — пожалуйста, заполните все разделы для обеспечения наилучшего ухода.",
    "completeAndContinue": "Завершить оценку младенца и продолжить",
    "sectionsComplete": "{{completed}} из {{total}} разделов заполнено",
    "monthsOld": "{{count}} мес.",
    "oneMonthOld": "1 мес.",
    "infantLabel": "младенец",
    "na": "Н/Д",
    "pronouns": {
      "heMale": "он",
      "hisMale": "его",
      "himMale": "его",
      "HeMale": "Он",
      "HisMale": "Его",
      "heFemale": "она",
      "hisFemale": "её",
      "himFemale": "её",
      "HeFemale": "Она",
      "HisFemale": "Её",
      "heNeutral": "малыш",
      "hisNeutral": "малыша",
      "himNeutral": "малыша",
      "HeNeutral": "Малыш",
      "HisNeutral": "Малыша"
    },
    "greeting": {
      "dearGuardianWithRel": "Уважаемый(-ая) {{name}} ({{relationship}} {{child}}),",
      "dearGuardian": "Уважаемый(-ая) {{name}},",
      "dearParents": "Уважаемые родители,",
      "intro": "Благодарим Вас за то, что привели {{child}} на {{visitType}}. Мы понимаем, что уход за малышом сопровождается множеством вопросов и переживаний, и хотим, чтобы Вы знали — мы всегда готовы Вам помочь. Ниже представлены результаты сегодняшнего осмотра и наши рекомендации по уходу за {{child}}.",
      "followUp": "контрольный осмотр",
      "assessment": "обследование"
    },
    "findings": {
      "title": "Что мы обнаружили сегодня",
      "howDoesItHappen": "Как это происходит?",
      "whatCanBeDone": "Что можно сделать?",
      "noConcerns": "Во время сегодняшнего обследования мы не обнаружили каких-либо конкретных проблем. {{child}} развивается хорошо. Ниже мы предоставили общие рекомендации для поддержки дальнейшего развития {{possessive}}.",
      "yourConcerns": "Ваши обеспокоенности",
      "concernsIntro": "Вы упомянули следующие обеспокоенности: {{concerns}}. Мы учли их в нашей оценке и рекомендациях ниже."
    },
    "tummyTime": {
      "title": "Программа «Время на животике»",
      "forChild": "Для {{child}} ({{age}}): {{minutes}}, {{frequency}}",
      "importance": "Время на животике — это самое важное упражнение для физического развития Вашего малыша. Оно укрепляет мышцы шеи, плеч и туловища, необходимые для переворачивания, сидения и ползания.",
      "minutes1": "3–5 минут",
      "frequency1": "2–3 раза в день",
      "tip1_1": "Начните с выкладывания на животик на Вашей груди, пока Вы в полулежачем положении",
      "tip1_2": "Положите малыша на твёрдую поверхность с маленьким валиком из полотенца под грудью",
      "tip1_3": "Будьте рядом, разговаривайте или пойте, чтобы малыш был вовлечён",
      "tip1_4": "Прекратите, если малыш расстроится, и попробуйте снова позже",
      "minutes2": "10–15 минут",
      "frequency2": "3–4 раза в день",
      "tip2_1": "Используйте развивающий коврик с яркими игрушками на уровне глаз",
      "tip2_2": "Поставьте маленькое зеркало перед малышом, чтобы стимулировать поднимание головы",
      "tip2_3": "Попробуйте выкладывать на животик на Ваших коленях для разнообразия",
      "tip2_4": "Поддержите малыша валиком из полотенца или подушкой для кормления под грудью",
      "minutes3": "20–30 минут",
      "frequency3": "4–5 раз в день",
      "tip3_1": "Расположите игрушки полукругом для стимулирования тянущихся движений и поворотов",
      "tip3_2": "Позвольте малышу играть на животике во время свободной игры на полу",
      "tip3_3": "Попробуйте опору на предплечья для укрепления верхней части тела",
      "tip3_4": "Стимулируйте переворачивание, располагая игрушки чуть в стороне и за пределами досягаемости",
      "minutes4": "30+ минут",
      "frequency4": "В течение дня во время игры",
      "tip4_1": "Позвольте малышу свободно исследовать пол в безопасном месте",
      "tip4_2": "Стимулируйте ползание, размещая игрушки на расстоянии",
      "tip4_3": "Поддерживайте попытки встать и передвигаться вдоль мебели",
      "tip4_4": "Продолжайте игры на полу как основную активность"
    },
    "headShape": {
      "title": "Рекомендации по форме головы",
      "alternateCot": "Чередуйте направление, в котором {{child}} смотрит в кроватке каждую ночь",
      "encourageLook": "Поощряйте {{child}} смотреть в сторону неуплощённой стороны во время игры",
      "minimiseFlat": "Минимизируйте время на плоских поверхностях — используйте слинг или носите {{child}} вертикально",
      "continueTummy": "Продолжайте выкладывание на животик под наблюдением как лучшее средство при уплощении",
      "noSleepChange": "НЕ меняйте положение для сна — всегда укладывайте {{child}} на спину для сна",
      "reassurance": "Большинство позиционных изменений формы головы значительно улучшаются по мере того, как Ваш малыш обретает контроль над головой и проводит меньше времени лёжа."
    },
    "feeding": {
      "title": "Рекомендации по кормлению",
      "sidePreference": "{{child}} предпочитает кормление с одной стороны. Попробуйте чередовать стороны при каждом кормлении для равномерного движения шеи. Если {{pronoun}} сопротивляется, попробуйте другое положение для кормления (например, «из-под руки») на менее предпочтительной стороне.",
      "difficultyLatching": "Отмечены трудности с захватом груди — рассмотрите консультацию специалиста по грудному вскармливанию, если это сохраняется.",
      "fussesDuringFeeds": "{{child}} беспокоится во время кормления — это может быть связано с рефлюксом или дискомфортом. Попробуйте меньшие, но более частые кормления.",
      "archesBack": "Выгибание спины во время кормления может указывать на рефлюкс. Держите {{child}} более вертикально во время и после кормления.",
      "fallsAsleep": "Если {{child}} быстро засыпает во время кормления, попробуйте мягкую стимуляцию (пощекочите стопы, прохладная салфетка) для более продолжительного кормления.",
      "spitsUp": "Частое срыгивание распространено у младенцев. Держите {{child}} вертикально 20–30 минут после кормления.",
      "refluxTitle": "Советы по управлению рефлюксом:",
      "reflux1": "Держите вертикально 20–30 минут после каждого кормления",
      "reflux2": "Предлагайте меньшие, но более частые кормления",
      "reflux3": "Аккуратно помогайте отрыгивать во время и после кормления",
      "reflux4": "Слегка приподнимите головной конец кроватки"
    },
    "carrying": {
      "title": "Рекомендации по ношению и удержанию",
      "hipHealthy": "Здоровое ношение для тазобедренных суставов",
      "hipHealthyDesc": "Носите {{child}}, расставив {{possessive}} ножки вокруг Вашего бедра в позе лягушки. Используйте переноску с широким основанием, поддерживающую бёдра от колена до колена.",
      "varyPositions": "Меняйте положения",
      "varyPositionsDesc": "Чередуйте руку, на которой Вы носите {{child}}. Попробуйте повернуть лицом от себя, чтобы стимулировать {{child}} осматриваться и укреплять мышцы шеи.",
      "forTorticollis": "При кривошее",
      "torticollisDesc": "Носите {{child}} так, чтобы {{pronoun}} был(-а) вынужден(-а) поворачивать голову к напряжённой стороне, чтобы Вас видеть. Когда {{child}} у Вас на руках, располагайте {{objective}} так, чтобы интересные предметы находились на менее предпочтительной стороне {{possessive}}.",
      "forHipDysplasia": "При дисплазии тазобедренного сустава",
      "hipDysplasiaDesc": "Всегда носите {{child}} с разведёнными вокруг Вас ножками (положение наездника). Избегайте узких переносок, которые прижимают ножки друг к другу. При пеленании позвольте ножкам {{possessive}} находиться в естественной позе лягушки."
    },
    "milestones": {
      "title": "Этапы развития",
      "disclaimer": "Каждый малыш развивается в своём темпе. Указанные выше этапы являются общими ориентирами. Если у Вас есть вопросы о развитии {{child}}, пожалуйста, обсудите их с нами или Вашим педиатром.",
      "notCompleted": "Отслеживание этапов развития не было проведено в ходе сегодняшнего обследования. Пожалуйста, обсудите любые вопросы о развитии с Вашим педиатром."
    },
    "carePlan": {
      "title": "План ухода за {{child}}",
      "phase": "Фаза",
      "frequencyLabel": "Частота:",
      "durationLabel": "Длительность:",
      "goals": "Цели",
      "techniques": "Методы",
      "visitFrequency": "Частота визитов:"
    },
    "homeAdvice": {
      "title": "Рекомендации для дома",
      "do": "Рекомендуется",
      "avoid": "Избегайте"
    },
    "redFlags": {
      "title": "Когда обратиться к нам или к педиатру",
      "urgentTitle": "Срочно обратитесь к врачу, если {{child}}:",
      "temperature": "Имеет температуру выше 38°C (до 3 месяцев) или 39°C (старше 3 месяцев)",
      "floppy": "Необычно вялый(-ая), сонный(-ая) или не реагирует",
      "vomiting": "Имеет рвоту фонтаном или рвоту с зелёной желчью",
      "refusesFeeds": "Отказывается от всех кормлений более 4–6 часов",
      "fontanelle": "Имеет выбухающий родничок (мягкое место)",
      "seizure": "Имеет судороги или необычные движения",
      "soonerTitle": "Запишитесь на приём раньше, если:",
      "notImproving": "Состояние {{child}} не улучшается",
      "newSymptoms": "Появляются новые симптомы, которые Вас беспокоят",
      "changeMovement": "Вы замечаете изменения в движениях или поведении {{possessive}}",
      "questionsWorries": "У Вас есть любые вопросы или беспокойства между визитами"
    },
    "parentNote": {
      "title": "Обращение к родителям",
      "bodyWithConditions": "Мы понимаем, что обследование малыша может вызывать тревогу. Пожалуйста, знайте, что состояние {{child}} очень распространено и хорошо поддаётся лечению и рекомендациям, которые мы изложили. Малыши замечательно адаптируются, и с Вашей любовью и правильным руководством большинство мышечно-скелетных проблем в младенчестве прекрасно разрешаются. Вы замечательные родители.",
      "bodyNoConditions": "Мы понимаем, что обследование малыша может вызывать тревогу. Пожалуйста, знайте, что развитие {{child}} выглядит здоровым, и мы всегда готовы поддержать Вас в любых вопросах. Малыши замечательно адаптируются, и с Вашей любовью и правильным руководством большинство мышечно-скелетных проблем в младенчестве прекрасно разрешаются. Вы замечательные родители.",
      "contactUs": "Если у Вас когда-либо возникнут вопросы между приёмами, пожалуйста, не стесняйтесь обращаться к нам. Нет слишком маленьких или глупых вопросов — мы всегда предпочтём, чтобы Вы спросили, а не переживали."
    },
    "nextSteps": {
      "title": "Дальнейшие шаги",
      "withFrequency": "Мы рекомендуем повторный осмотр {{child}} {{frequency}}.",
      "withoutFrequency": "Мы назначим следующий визит {{child}} в зависимости от прогресса {{possessive}}.",
      "bookingIntro": "Для записи на следующий приём или если у Вас есть вопросы, пожалуйста, свяжитесь с нами:",
      "scanToBook": "Сканируйте для записи"
    }
  },
  "exerciseProgram": {
    "title": "Программа упражнений",
    "homeTitle": "Домашняя программа упражнений",
    "generated": "Создано",
    "noProgram": "Программа упражнений ещё не создана. Нажмите \"Создать программу\" для генерации индивидуальной программы.",
    "generatePlan": "Создать программу",
    "regenerate": "Пересоздать",
    "generating": "Создание...",
    "downloading": "Загрузка...",
    "downloadPdf": "Скачать PDF",
    "generateFailed": "Не удалось создать программу упражнений",
    "pdfFailed": "Не удалось создать PDF упражнений",
    "pdfDownloadFailed": "Не удалось скачать PDF",
    "contraindicationWarnings": "Предупреждения о противопоказаниях",
    "sets": "Подходы",
    "reps": "Повторения",
    "hold": "Удержание",
    "instructions": "Инструкции",
    "guidedExercise": "Упражнение с инструктором",
    "completed": "Выполнено",
    "guidedResults": "Результаты упражнений с инструктором",
    "totalExercises": "Всего упражнений",
    "regions": "Области"
  },
  "consent": {
    "title": "Управление согласиями",
    "loadingConsents": "Загрузка согласий...",
    "noData": "Данные о согласиях отсутствуют.",
    "viewHistory": "Показать историю",
    "hideHistory": "Скрыть историю",
    "viewText": "Показать текст",
    "hideText": "Скрыть текст",
    "signConsent": "Подписать согласие",
    "signing": "Подписание...",
    "revoke": "Отозвать",
    "revoking": "Отзыв...",
    "signed": "Подписано",
    "revoked": "Отозвано",
    "consentText": "Текст согласия",
    "history": "История согласий",
    "noHistory": "Записей в истории нет.",
    "actionSigned": "подписано",
    "actionRevoked": "отозвано",
    "by": "пользователем",
    "status": {
      "active": "Активно",
      "not_signed": "Не подписано",
      "revoked": "Отозвано"
    }
  },
  "imaging": {
    "title": "Загрузка снимков",
    "dismiss": "Закрыть",
    "dragDrop": "Перетащите файлы сюда или",
    "browseFiles": "выберите файлы",
    "acceptedFormats": "JPEG, PNG, PDF до 10 МБ каждый",
    "uploading": "Загрузка...",
    "uploadedFiles": "Загруженные файлы",
    "uploaded": "Загружено",
    "analyzeWithAI": "Анализ с помощью ИИ",
    "analyzing": "ИИ анализирует...",
    "aiAnalysisResults": "Результаты анализа ИИ",
    "aiAssistedObservation": "Наблюдение с помощью ИИ — требуется верификация врачом",
    "analyzed": "Проанализировано",
    "findingsNotConfirmed": "Результаты не подтверждены, пока вы не проверите каждый из них",
    "findings": "Результаты визуализации",
    "measurements": "Измерения",
    "impressions": "Заключения",
    "normal": "Норма",
    "reject": "Отклонить",
    "review": "Обзор визуализации",
    "comparison": "Сравнение визуализации",
    "overallChange": "Общее изменение",
    "improved": "Улучшение",
    "stable": "Стабильно",
    "progressed": "Прогрессирование",
    "aiAssisted": "Анализ с помощью ИИ — проверен и утверждён врачом",
    "analyzeButton": "Анализ с помощью ИИ",
    "uploadImage": "Загрузить изображение",
    "compareButton": "Сравнить изображения",
    "dateTaken": "Дата съёмки",
    "viewSequence": "Проекция / Серия"
  },
  "labResults": {
    "title": "Лабораторные результаты",
    "valuePlaceholder": "Значение",
    "normal": "Норма",
    "autoInterpretation": "Автоматическая интерпретация",
    "savedSuccessfully": "Успешно сохранено",
    "saveResults": "Сохранить результаты"
  },
  "copilot": {
    "aggravating": "Усиливающие",
    "analyze": "Анализ с ИИ",
    "analyzing": "Анализ описания...",
    "carePhase": "Рекомендуемая Фаза Лечения",
    "clarification": "ИИ нужно уточнение",
    "close": "Закрыть",
    "complaints": "Жалобы",
    "confidence": "уверенность",
    "diagnoses": "Диагнозы",
    "expected": "Ожидаемое",
    "followUp": "Наблюдение",
    "functionalChanges": "Функциональные Изменения",
    "initial": "Начальная",
    "initialExam": "Первичный Осмотр",
    "language": "Язык",
    "listening": "Слушает...",
    "loadingTests": "Получение рекомендаций...",
    "newComplaints": "Новые Жалобы",
    "painComparison": "Сравнение Боли",
    "parsedFindings": "Результаты ИИ",
    "planUpdates": "Обновления Плана",
    "previousNarrative": "Предыдущее описание:",
    "proceedToTests": "Перейти к Физикальному Осмотру →",
    "progressSummary": "Сводка Прогресса",
    "reExamComplete": "Повторный Осмотр Завершён",
    "reExamSaved": "Все данные сохранены.",
    "redFlags": "Выявленные Красные Флаги",
    "relieving": "Облегчающие",
    "resolved": "Устранено",
    "saveComplete": "Сохранить и Завершить",
    "saving": "Сохранение...",
    "startReExam": "Начать ИИ Повторный Осмотр",
    "startVoice": "Начать голосовой ввод",
    "starting": "Запуск...",
    "stop": "Стоп",
    "stopVoice": "Стоп",
    "submitClarification": "Отправить и Перепроанализировать",
    "submitResults": "Отправить и Обновить DDx",
    "subtitle": "Повторный осмотр",
    "testRationale": "Почему эти тесты?",
    "testResults": "Результаты Тестов",
    "tests": "тесты",
    "title": "ИИ Клинический Ассистент",
    "typeAnswer": "Введите ваш ответ...",
    "updatedDiagnoses": "Обновлённые Диагнозы",
    "updatingDdx": "Обновление диагноза...",
    "voiceNotSupported": "Голосовой ввод недоступен. Введите заметки текстом.",
    "wellnessScores": "Оценка физической формы"
  },
  "email": {
    "attachPdf": "Прикрепить PDF отчёт",
    "cancel": "Отмена",
    "language": "Язык Отчёта",
    "patientEmail": "Email Пациента",
    "send": "Отправить",
    "sendReport": "Отправить Отчёт",
    "sending": "Отправка...",
    "templatePreview": "Предпросмотр Шаблона"
  },
  "exercises": {
    "title": "Программа упражнений",
    "current": "Текущие упражнения",
    "history": "История упражнений",
    "addExercise": "Добавить упражнение",
    "recommended": "Рекомендуемые",
    "progress": "Прогрессия",
    "pause": "Пауза",
    "resume": "Возобновить",
    "remove": "Удалить",
    "logSession": "Записать",
    "logAll": "Записать все",
    "printSheet": "Распечатать",
    "adherence": "Приверженность",
    "excellent": "Отлично",
    "good": "Хорошо",
    "needsImprovement": "Нужно улучшить",
    "atRisk": "Под угрозой",
    "setsCompleted": "Подходов",
    "repsCompleted": "Повторений",
    "painDuring": "Боль во время",
    "painAfter": "Боль после",
    "difficulty": "Сложность",
    "tooEasy": "Слишком легко",
    "justRight": "В самый раз",
    "tooHard": "Слишком тяжело",
    "level1": "Начинающий",
    "level2": "Средний",
    "level3": "Продвинутый",
    "level4": "Атлетический",
    "level5": "Элитный",
    "activeCare": "Активный уход",
    "correctiveCare": "Коррекция",
    "maintenance": "Поддержание",
    "myObligations": "Моё тело мои обязанности",
    "allDoneToday": "Всё сделано на сегодня!",
    "keepGoing": "Продолжайте!",
    "greatConsistency": "Отличная последовательность!",
    "sets": "Подходы",
    "reps": "Повторения",
    "hold": "Удержание",
    "rest": "Отдых",
    "frequency": "Частота",
    "perWeek": "в неделю",
    "equipment": "Оборудование",
    "formCheckpoints": "Контрольные точки",
    "contraindications": "Противопоказания",
    "progressionCriteria": "Критерии прогрессии",
    "prescribedDate": "Назначено",
    "expiresDate": "Истекает",
    "supersededBy": "Заменено на",
    "noExercises": "Упражнения не назначены",
    "addFromLibrary": "Добавить из библиотеки",
    "confirmRemove": "Удалить это упражнение?",
    "progressTo": "Перейти на следующий уровень",
    "exerciseLibrary": "Библиотека упражнений",
    "filterByRegion": "По области",
    "filterByLevel": "По уровню",
    "filterByCategory": "По категории",
    "addToPlan": "Добавить в план",
    "phase": "Фаза",
    "notes": "Заметки",
    "allLevels": "Все уровни",
    "allCategories": "Все категории",
    "allRegions": "Все области",
    "xTimesPerWeek": "{{count}}x в неделю",
    "painScale": "Боль (0-10)",
    "streakDays": "дней подряд",
    "loggedToday": "Записано сегодня",
    "noData": "Нет данных",
    "thisWeek": "на этой неделе",
    "none": "Упражнения ещё не назначены.",
    "doWithCamera": "С Камерой",
    "markDone": "Выполнено",
    "start": "Начать",
    "cancel": "Отмена",
    "finish": "Завершить",
    "setDone": "Подход Завершён",
    "nextSet": "Следующий подход через",
    "formScore": "Качество Выполнения",
    "allDone": "Всё Выполнено!",
    "voice": {
      "begin": "Начинайте упражнение"
    },
    "feedback": {
      "great": "Отличная техника!",
      "good": "Хорошо, попробуйте чуть глубже",
      "watch": "Следите за техникой — полный диапазон движения",
      "excellent": "Превосходно!"
    }
  },
  "funcMovement": {
    "accept": "Принять",
    "aiSummary": "Клиническое Резюме ИИ",
    "analyzing": "Анализ движения...",
    "back": "Назад",
    "categoryBreakdown": "Разбивка по Категориям",
    "generateReport": "Создать Отчёт",
    "overallScore": "Общий Балл",
    "patientReady": "Пациент Готов",
    "quickScreen": "Быстрый Скрининг (~3 мин)",
    "readToPatient": "Прочитайте пациенту:",
    "recommendations": "Рекомендации",
    "redo": "Повторить",
    "result": "Результат",
    "setupInstructions": "Расположите устройство на устойчивой поверхности в 2 метрах от пациента",
    "skip": "Пропустить",
    "startTest": "Начать Тест",
    "stopCapture": "Стоп",
    "title": "Функциональная Оценка Движения"
  },
  "gamification": {
    "achievements": "Достижения",
    "balance": "Баланс",
    "best": "Лучшее",
    "bodyPerformance": "Оценка физической формы",
    "change": "Изменение",
    "completedExercises": "Выполненные упражнения",
    "converted": "Присоединился",
    "copied": "Скопировано! Поделитесь с друзьями",
    "current": "Текущий",
    "dailyCheckIn": "Ежедневная Отметка",
    "dayStreak": "дней подряд",
    "days": "дней",
    "energyLevel": "Уровень энергии",
    "howDidYouMove": "Как вы двигались сегодня?",
    "initial": "Начальный",
    "lifestyle": "Образ Жизни",
    "movement": "Движение",
    "nextTier": "Следующий",
    "noAchievementsInCategory": "Нет достижений в этой категории",
    "noStreaks": "Начните первую серию сегодня!",
    "nowScore": "Сейчас",
    "pending": "Ожидает",
    "personalBest": "Новый Рекорд!",
    "progressSnapshot": "Ваш Прогресс",
    "recovery": "Восстановление",
    "referralMessage": "Рекомендую",
    "referralProgram": "Программа Рекомендаций",
    "referralUseCode": "Используйте мой код",
    "retry": "Повторить",
    "shareCode": "Копировать и Поделиться",
    "sleepQuality": "Качество сна",
    "sortCategory": "По категории",
    "sortRecent": "По дате",
    "startScore": "Старт",
    "streaks": "Ваши Серии",
    "strength": "Сила",
    "stressLevel": "Уровень стресса (1=низкий, 5=высокий)",
    "submitCheckIn": "Отправить Отметку",
    "submitting": "Отправка...",
    "total": "Всего",
    "visits": "визитов",
    "yourCode": "Ваш код рекомендации"
  },
  "lifestyle": {
    "activity": "Физическая Активность",
    "alcohol": "Употребление алкоголя?",
    "answered": "отвечено",
    "breaks": "Регулярные перерывы?",
    "diet": "Опишите вашу диету?",
    "ergonomics": "Работа и Эргономика",
    "exerciseFreq": "Как часто тренируетесь?",
    "exerciseTypes": "Какой тип?",
    "habits": "Привычки",
    "howActive": "Насколько вы активны?",
    "nutrition": "Питание и Гидратация",
    "occupation": "Уровень ежедневной активности?",
    "quickMode": "← Быстрый режим",
    "quickTitle": "Быстрая Проверка Образа Жизни",
    "saving": "Сохранение...",
    "sitting": "Часов сидя в день?",
    "sittingQ": "Часов сидя?",
    "sleep": "Сон",
    "sleepHours": "Часов в ночь?",
    "sleepQ": "Качество сна?",
    "sleepQuality": "Качество сна?",
    "smoking": "Вы курите?",
    "stress": "Стресс",
    "stressLevel": "Уровень стресса?",
    "stressQ": "Уровень стресса?",
    "stressSources": "Основные источники?",
    "title": "Оценка Образа Жизни",
    "wantMore": "Хотите больше деталей? Разверните полную оценку →",
    "water": "Стаканов воды в день?"
  },
  "notifications": {
    "empty": "Нет уведомлений",
    "markAllRead": "Отметить все как прочитанные",
    "title": "Уведомления"
  },
  "painMap": {
    "back": "Сзади",
    "clearView": "Очистить",
    "front": "Спереди",
    "instruction": "Нажмите на тело, чтобы отметить точки боли",
    "markers": "точек",
    "title": "Отметить Расположение Боли",
    "undo": "Отменить"
  },
  "planner": {
    "headers": {
      "phase": "Фаза",
      "frequency": "Частота",
      "duration": "Длительность (нед.)",
      "action": "Действие"
    },
    "totalVisits": "Всего посещений до поддерживающего ухода: {{count}}"
  },
  "portal": {
    "achievements": "Ваши Достижения",
    "balance": "Баланс",
    "bodyPerformance": "Показатели Вашего Тела",
    "breakdown": "Разбивка Баллов",
    "calmToStressed": "Спокойный → Стресс",
    "checkedIn": "Отмечено сегодня!",
    "codeHint": "Проверьте отчёт или спросите на ресепшен",
    "copied": "Скопировано!",
    "copyShare": "Копировать и Поделиться",
    "dailyQuote": "Каждый шаг вперёд делает вас сильнее.",
    "dayStreak": "дней подряд",
    "didExercises": "Вы делали упражнения?",
    "doneToday": "сегодня",
    "download": "Скачать",
    "earned": "получено",
    "energyLevel": "Уровень энергии?",
    "enterCode": "Введите код доступа",
    "estimatedNext": "Следующий визит",
    "exercises": "Упражнения",
    "faq": "Частые Вопросы",
    "faqAfterPain": "Что после боли?",
    "faqAfterPainA": "Переход к этапу «Поддерживающая забота».",
    "faqFreqActive": "На этапе «Терапия Облегчения» — 2 визита в неделю.",
    "faqFreqMaint": "Сейчас достаточно ежемесячных визитов.",
    "faqFrequency": "Как часто приходить?",
    "faqScoring": "Как работает оценка?",
    "faqScoringA": "Оценка по 5 областям: Движение, Сила, Баланс, Восстановление, Образ жизни.",
    "faqWhenBetter": "Когда станет лучше?",
    "faqWhenBetterA": "Обычно в течение 2-4 недель.",
    "firstVisit": "Первый Визит",
    "friendsJoined": "Друзья присоединились",
    "health": "Здоровье",
    "howFeeling": "Как вы себя чувствуете?",
    "howMove": "Как вы двигались сегодня?",
    "invalidCode": "Неверный код.",
    "journeyTimeline": "Ваш Путь",
    "lifestyle": "Образ Жизни",
    "movement": "Движение",
    "myExercises": "Мои Упражнения",
    "myReports": "Мои Отчёты",
    "needHelp": "Нужна помощь? Свяжитесь с клиникой",
    "networkError": "Ошибка подключения.",
    "next": "Далее",
    "nextVisit": "Следующий визит",
    "no": "Нет",
    "noAchievementsYet": "Отмечайтесь ежедневно для получения наград!",
    "noExercises": "Упражнения ещё не назначены.",
    "noProgress": "Чтобы увидеть прогресс, необходимо пройти как минимум две оценки.",
    "noReferral": "Попросите код у клиники.",
    "noReports": "Отчётов пока нет.",
    "now": "Сейчас",
    "personalBest": "Новый Рекорд!",
    "personalizedTips": "Ваш План Улучшения",
    "pointsImproved": "баллов улучшения",
    "recovery": "Восстановление",
    "refer": "Рекомендовать",
    "referralMsg": "Рекомендую",
    "reports": "Отчёты",
    "seeFullProgress": "Полный прогресс →",
    "shareWellness": "Поделитесь Здоровым Путешествием!",
    "sinceLast": "с последнего визита",
    "sleepQuality": "Как вы спали?",
    "startStreak": "Начните сегодня!",
    "strength": "Сила",
    "stressLevel": "Уровень стресса?",
    "totalShares": "Всего рекомендаций",
    "treatmentGoals": "Ваши Цели",
    "useCode": "Использовать код",
    "verifying": "Проверка...",
    "viewAll": "Все →",
    "viewCarePlan": "План лечения →",
    "viewDashboard": "Панель управления",
    "welcome": "Добро пожаловать",
    "yes": "Да",
    "yourCarePlan": "Ваш План Лечения",
    "yourJourney": "Ваш Путь к Здоровью",
    "yourProgress": "Ваш Прогресс",
    "yourReferralCode": "Ваш код рекомендации",
    "hiName": "Привет, {{name}}!",
    "stageRelief": "Терапия Облегчения",
    "stageRehab": "Реабилитация",
    "stageWellness": "Поддерживающая забота"
  },
  "portalAdmin": {
    "accessCode": "Код Доступа",
    "generate": "Создать Код",
    "generating": "Создание...",
    "noAccess": "Доступ ещё не настроен",
    "patientPortal": "Доступ к Порталу Пациента"
  },
  "save": {
    "ago": "назад",
    "justNow": "Только что",
    "saveDraft": "Сохранить Черновик",
    "saveExit": "Сохранить и Выйти",
    "saved": "Сохранено",
    "saving": "Сохранение...",
    "unsaved": "Несохранённые изменения",
    "upToDate": "Актуально"
  },
  "screening": {
    "alerts": "Клинические Предупреждения",
    "bpHeadache": "Рекомендуется измерение давления при головной боли.",
    "bpRecommended": "Рекомендуется Измерение Давления",
    "cnHeadache": "Пациент с головной болью. Рекомендуется оценка черепных нервов.",
    "cnNeuro": "Рекомендуется Неврологический Скрининг",
    "cnNeuroReason": "Шейная жалоба с неврологическими симптомами.",
    "cnRecommended": "Рекомендуется Осмотр Черепных Нервов",
    "save": "Сохранить",
    "saveResults": "Сохранить Результаты",
    "vbiReason": "Шейная жалоба с головокружением. Требуется VBI перед манипуляцией.",
    "vbiRequired": "Требуется Скрининг Позвоночной Артерии"
  },
  "softTissue": {
    "confirmWith": "Подтвердить с",
    "more": "ещё доступно",
    "noStructures": "Структуры не загружены для выбранных областей.",
    "palpation": "Руководство по Пальпации",
    "showLess": "← Показать только 3",
    "significance": "Клиническое Значение",
    "title": "Оценка Мягких Тканей",
    "top3": "Топ 3"
  },
  "uploads": {
    "addToFile": "Добавить в Медкарту",
    "description": "Описание (необязательно)",
    "logToday": "Записать Сегодня",
    "myUploads": "Мои Файлы",
    "trackBody": "Отслеживание Тела",
    "upload": "Загрузить",
    "uploading": "Загрузка..."
  },
  "intake": {
    "loading": "Загрузка...",
    "oops": "Ошибка",
    "noToken": "Токен не предоставлен.",
    "linkExpired": "Ссылка истекла. Свяжитесь с клиникой для получения новой.",
    "invalidLink": "Недействительная ссылка. Свяжитесь с клиникой.",
    "somethingWrong": "Что-то пошло не так.",
    "unableToConnect": "Не удалось подключиться. Проверьте интернет."
  },
  "onboarding": {
    "stepOf": "Шаг {{current}} из {{total}}",
    "finishLater": "Закончу позже",
    "back": "Назад",
    "next": "Далее",
    "completeSetup": "Завершить настройку",
    "welcome": {
      "title": "Добро пожаловать в MSK Insight",
      "subtitle": "Настроим вашу клинику за 5 минут. Всё можно изменить позже в Настройках.",
      "clinicTypePrompt": "Какой тип вашей клиники?",
      "getStarted": "Начать"
    },
    "clinicIdentity": {
      "title": "Данные клиники",
      "subtitle": "Основная информация о вашей клинике.",
      "clinicName": "Название клиники",
      "phone": "Телефон",
      "email": "Email",
      "address": "Адрес",
      "whatsapp": "WhatsApp",
      "website": "Сайт",
      "placeholderName": "напр. Центр хиропрактики",
      "placeholderPhone": "+357 25 344747",
      "placeholderEmail": "info@yourclinic.com",
      "placeholderAddress": "пр. Макариоса 25, 3040 Лимасол, Кипр",
      "placeholderWhatsapp": "+357 99 123456",
      "placeholderWebsite": "https://yourclinic.com",
      "errorClinicName": "Название клиники обязательно",
      "errorPhone": "Номер телефона обязателен",
      "errorEmail": "Email обязателен"
    },
    "team": {
      "title": "Ваша команда",
      "subtitle": "Кто работает в вашей клинике? Можно добавить участников позже.",
      "lead": "Руководитель",
      "fullName": "Полное имя",
      "roleTitle": "Роль / Должность",
      "credential": "Профессиональная квалификация",
      "bio": "Краткая биография",
      "bioPlaceholder": "Краткая профессиональная биография (необязательно)",
      "leadOwner": "Руководитель / Владелец клиники",
      "add": "Добавить",
      "save": "Сохранить",
      "cancel": "Отмена",
      "addTeamMember": "+ Добавить участника",
      "select": "-- Выберите --",
      "placeholderName": "напр. Мария Георгиу",
      "placeholderTitle": "напр. Главный хиропрактик"
    },
    "modalities": {
      "title": "Клинические методы",
      "subtitle": "Какие процедуры предлагает ваша клиника? Рекомендации AI будут ограничены этими методами."
    },
    "assessmentTools": {
      "title": "Инструменты оценки",
      "subtitle": "Какие диагностические инструменты вы используете? Можно пропустить этот шаг."
    },
    "carePathway": {
      "title": "Путь лечения",
      "subtitle": "Как вы структурируете лечение пациентов? Заполнено на основе типа клиники."
    },
    "reportPreferences": {
      "title": "Настройки отчётов",
      "subtitle": "Как должны выглядеть отчёты пациентов и письма врачам?"
    },
    "integrations": {
      "title": "Интеграции",
      "subtitle": "Подключите существующие инструменты. Можно настроить позже.",
      "practiceHub": "PracticeHub",
      "practiceHubDesc": "Синхронизация записей и данных пациентов",
      "emailSmtp": "Email (SMTP)",
      "emailSmtpDesc": "Отправка отчётов и напоминаний пациентам",
      "aiAssistant": "AI Ассистент",
      "aiAssistantDesc": "Нарративы отчётов и клинические выводы на основе AI",
      "configureAfter": "Настройте в Настройки → Интеграции после установки.",
      "allOptional": "Все интеграции необязательны и могут быть настроены в любое время."
    },
    "review": {
      "title": "Проверьте настройку",
      "subtitle": "Всё выглядит хорошо? Можно изменить что угодно позже в Настройках.",
      "clinicIdentity": "Данные клиники",
      "yourTeam": "Ваша команда",
      "clinicalModalities": "Клинические методы",
      "assessmentTools": "Инструменты оценки",
      "carePathway": "Путь лечения",
      "reportPreferences": "Настройки отчётов",
      "clinicType": "Тип клиники",
      "edit": "Изменить",
      "notConfigured": "Ещё не настроено",
      "name": "Название",
      "phone": "Телефон",
      "email": "Email",
      "address": "Адрес",
      "languages": "Языки",
      "notSet": "Не указано"
    },
    "completion": {
      "title": "Ваша клиника готова!",
      "subtitle": "Всё настроено. Можете начать приём пациентов прямо сейчас или настроить далее.",
      "addFirstPatient": "Добавить первого пациента",
      "exploreDashboard": "Обзор панели",
      "customiseSettings": "Настроить параметры",
      "redirecting": "Перенаправление на панель через {{seconds}} секунд..."
    }
  },
  "session": {
    "warning": {
      "message": "Ваша сессия истечёт через 5 минут. Нажмите, чтобы остаться в системе.",
      "button": "Остаться в системе"
    },
    "expired": {
      "toast": "Ваша сессия истекла. Пожалуйста, войдите снова."
    }
  },
  "reportV2": {
    "rv2CoverTitle": "Ваш персональный план восстановления и работоспособности",
    "rv2PreparedFor": "Подготовлено для **{patient_full_name}** · {report_date}",
    "rv2ToldLabel": "Что вы нам рассказали",
    "rv2GoalsLabel": "Что вы хотите вернуть",
    "rv2WhatItMeansLabel": "Что это значит:",
    "rv2ContributingLabel": "Способствующие области:",
    "rv2HowWeCanHelpLabel": "Как мы можем помочь",
    "rv2AlsoCovered": "Также охвачено вашим планом",
    "rv2RecoveryDialTitle": "Ваш показатель восстановления",
    "rv2ProgressHeading": "Ваш прогресс с последнего визита",
    "rv2ScheduleHeading": "Ваш график лечения",
    "rv2ScheduleFootnote": "Протоколы лечения проверяются по последним клиническим данным.",
    "rv2BookingDatesNote": "Фактические даты ваших визитов могут немного отличаться в зависимости от наличия свободного времени в расписании.",
    "rv2Ongoing": "Постоянно",
    "rv2CarePlanHeading": "Ваш персональный план ухода",
    "rv2HomeAdviceHeading": "Ваш план ухода дома",
    "rv2ColDoNow": "Делайте сейчас",
    "rv2ColAvoid": "Чего избегать",
    "rv2ColLifestyle": "Изменения образа жизни",
    "rv2ColSupplement": "Добавка",
    "rv2ColDosage": "Дозировка",
    "rv2ColWhen": "Когда принимать",
    "rv2ColWhatItDoes": "Что делает",
    "rv2AsDirected": "По назначению",
    "rv2SupportsRecovery": "Поддерживает восстановление и хорошее самочувствие",
    "rv2Daily": "Ежедневно",
    "rv2QrCaption": "Отсканируйте для онлайн-записи",
    "rv2ContentsStory": "Ваша история",
    "rv2ContentsFound": "Что мы обнаружили",
    "rv2ContentsCarePlan": "Ваш план ухода",
    "rv2ContentsNext": "Следующие шаги",
    "rv2Call": "Позвонить",
    "rv2Online": "Онлайн",
    "rv2Page": "Страница",
    "rv2PainRatingLabel": "ваша оценка боли",
    "rv2NotRecorded": "Не зафиксировано в этот визит",
    "rv2OpeningHours": "Часы работы:",
    "rv2GoalsTarget": "Это наша общая цель, и план ниже составлен так, чтобы привести вас к ней.",
    "rv2HowWeCanHelpText": "уход, направленный на то, чтобы успокоить раздражённую ткань, восстановить движение и силу, которые её защищают, и помочь вам сохранять хорошее самочувствие надолго.",
    "rv2GoldenIntro": "Это главное, о чём стоит помнить между визитами. Следуя этим рекомендациям, вы получите наилучший результат от лечения.",
    "rv2ExerciseNote": "Все показанные или обсуждаемые упражнения приведены только как примеры. Ваш специалист по реабилитации назначит именно те упражнения, которые подходят вам на нужном этапе лечения.",
    "rv2TroublingFor": "беспокоит вас уже",
    "rv2ByYourChiropractor": "Ваш хиропрактик {name} ({credential})",
    "rv2WhyLabel": "Почему мы это делаем",
    "rv2WhyText": "В The Chiropractic Center мы создали команду, усиленную технологиями, ориентированную на людей и объединяющую разные специальности, с одной задачей: помочь вам и дать вам силы достичь ваших целей. Мы ищем настоящую причину, восстанавливаем то, что нужно вашему телу, и возвращаем вам ответственность за собственное здоровье. А когда вы будете готовы к большему, чем восстановление, забота и здоровье на всю жизнь уже ждут вас. Всегда ваш выбор, всегда ваш темп.",
    "rv2JourneyCaption": "успокоить · восстановить · сохранить на всю жизнь",
    "rv2JourneyChoice": "Третий этап это приглашение. Всегда ваш выбор.",
    "rv2WhatItMeansFallback": "Структуры в этой области раздражены и нуждаются в поддержке, а целенаправленный поэтапный план поможет справиться с этой проблемой",
    "rv2PageOf": "из"
  },
  "versionNudge": {
    "message": "Доступна новая версия",
    "reload": "Обновить",
    "later": "Позже"
  },
  "autosave": {
    "finalizedNothingToSave": "Оценка завершена. Сохранять больше нечего.",
    "finalizedShort": "Завершено"
  },
  "reportGenerator": {
    "emailNotEnabled": "Отправка email для этой клиники пока не включена. Попросите администратора настроить её.",
    "emailNeedsFinalize": "Завершите оценку, прежде чем отправлять отчёт пациенту по email."
  },
  "amend": {
    "inProgressTitle": "Идёт внесение изменений",
    "inProgressBody": "Версия {{version}} остаётся активной и неизменной, пока вы не нажмёте «Завершить», что опубликует версию {{next}}.",
    "button": "Изменить отчёт",
    "reopening": "Открытие...",
    "buttonHint": "Открыть этот выпущенный отчёт заново, чтобы опубликовать исправленную версию",
    "currentVersion": "Текущая версия: {{version}}",
    "failed": "Не удалось открыть отчёт для внесения изменений."
  },
  "pushStatus": {
    "delivered": "Отправлено в PracticeHub v{{version}}",
    "retrying": "PracticeHub: повтор в {{time}}",
    "failed": "PracticeHub: не отправлено после {{attempts}} попыток",
    "pushNow": "Отправить сейчас",
    "pushing": "Отправка…"
  },
  "lifecycle": {
    "draft": "Черновик",
    "confirmedNotIssued": "Подтверждено — не выпущено",
    "amending": "Идёт внесение изменений",
    "issued": "Выпущено v{{version}}"
  },
  "sprint6": {
    "journeyWeekByWeek": "По неделям",
    "journeyWeekLabel": "Неделя {{n}}",
    "journeyAnd": "и",
    "journeyOr": "или",
    "journeyWith": "с",
    "journeyGapWeek": "на этой неделе визита нет",
    "journeyChoiceNote": "Если указаны два имени, при записи мы подтвердим, к кому вы придёте.",
    "journeyThenMaintenance": "затем Wellness Care каждые 6 недель",
    "journeyPractitionerColumn": "Специалист"
  },
  "letterMachine": {
    "title": "Сформировать письмо",
    "letterType": "Тип письма",
    "typeReferral": "Направление",
    "typeProgress": "Динамика",
    "typeInsurance": "Для страховой",
    "recipient": "Получатель",
    "recipientHintReferral": "например, «д-р Джейн Смит»",
    "recipientHintProgress": "например, «д-р Джейн Смит» (или оставьте пустым для медкарты пациента)",
    "recipientHintInsurance": "например, название страховой компании, или оставьте пустым для «По месту требования»",
    "policyRef": "Номер полиса / страхового случая (необязательно)",
    "generate": "Сформировать",
    "regenerate": "Сформировать заново",
    "generating": "Формирование…",
    "editableDraft": "Редактируемый черновик",
    "editsNote": "Внесённые здесь изменения учитываются при копировании, скачивании, передаче в PracticeHub и отправке по эл. почте.",
    "copy": "Копировать",
    "copied": "Письмо скопировано в буфер обмена",
    "copyFailed": "Не удалось скопировать — выделите и скопируйте вручную",
    "downloadPdf": "Скачать PDF",
    "rendering": "Подготовка…",
    "pushToPracticeHub": "Передать в PracticeHub",
    "pushing": "Передача…",
    "emailToPatient": "Отправить пациенту по эл. почте",
    "sending": "Отправка…",
    "englishOnly": "Письма составляются на английском языке.",
    "requests": "Запросы",
    "requestsIntro": "Отметьте, что требуется. Предлагаемые пункты формируются на основе тревожных признаков и рабочей гипотезы; снимите отметки с ненужных.",
    "addRequest": "Добавить запрос",
    "noRequests": "Ничего не выбрано: письмо будет содержать только клиническую информацию.",
    "loadingSuggestions": "Загрузка предложений…",
    "kind": "Вид",
    "kindImaging": "Визуализация",
    "kindOpinion": "Консультация специалиста",
    "kindEmergency": "Экстренное направление",
    "kindUpdateOnly": "Только клиническая информация",
    "modality": "Метод исследования",
    "specialty": "Специальность",
    "region": "Область",
    "purpose": "Цель",
    "purposeCustom": "Другая цель (укажите)",
    "urgency": "Срочность",
    "urgencyRoutine": "Планово",
    "urgencySoon": "В ближайшее время",
    "urgencyUrgent": "Срочно",
    "urgencyEmergency": "Экстренно",
    "suggested": "Рекомендовано",
    "fromRedFlag": "по тревожному признаку",
    "fromHypothesis": "по рабочей гипотезе",
    "remove": "Удалить",
    "moveUp": "Переместить вверх",
    "moveDown": "Переместить вниз",
    "regionNone": "Область не указана"
  },
  "phV3": {
    "title": "PracticeHub v3 (новый API)",
    "intro": "Для перехода на новый API PracticeHub. Пока не используется: каждый ресурс ниже остаётся на старом подключении до октябрьской проверки.",
    "keyLabel": "Ключ API v3 (начинается с phk_)",
    "keyPlaceholder": "phk_…",
    "fingerprint": "Отпечаток ключа: {{fp}} — оставьте пустым, чтобы сохранить",
    "save": "Сохранить ключ v3",
    "saving": "Сохранение…",
    "saved": "Ключ PracticeHub v3 сохранён.",
    "accepted": "Сохранено — PracticeHub v3 принял ключ.",
    "readOnlyWarn": "Этот ключ может записывать. Создайте ключ только для чтения для MSK Insight и сохраните его.",
    "tzWarn": "Часовой пояс аккаунта — {{tz}}. MSK Insight читает время клиники как Europe/Nicosia, поэтому чтение записей на приём через v3 будет отклоняться, пока это не исправлено.",
    "refused": "Сохранено, но PracticeHub отклонил ключ. Проверьте, что ключ скопирован полностью.",
    "rateLimited": "Сохранено, но PracticeHub сейчас ограничивает запросы. Ключ будет проверен снова при следующем сохранении.",
    "untested": "Сохранено, но не удалось связаться с PracticeHub для проверки.",
    "isLegacy": "Это ключ старого API PracticeHub. Он относится к полю старого ключа выше; это поле принимает только ключи нового API, начинающиеся с phk_. Ничего не сохранено.",
    "invalidShape": "Это не ключ API v3 PracticeHub. Скопируйте его снова: PracticeHub → Developers → API Keys. Ничего не сохранено.",
    "notConfigured": "Сохраните ключ PracticeHub v3, прежде чем переводить ресурс на v3.",
    "writeKeyLabel": "Ключ записи v3 (начинается с phk_)",
    "writeKeyHint": "Второй ключ с правом записи, используется ТОЛЬКО для отправки отчётов. Чтение и синхронизация никогда его не используют. Создайте его в PracticeHub → Developers → API Keys с Access level: Read and write.",
    "writeSave": "Сохранить ключ записи v3",
    "writeSaved": "Ключ записи PracticeHub v3 сохранён.",
    "writeAccepted": "Сохранено — PracticeHub v3 принял ключ, и он может записывать.",
    "writeNoScope": "Сохранено, но этот ключ не может записывать. Для отправки отчётов создайте ключ с Access level: Read and write.",
    "writeUntested": "Сохранено, но не удалось связаться с PracticeHub для проверки.",
    "patientsNeedsMrn": "Переключатель пациентов остаётся выключенным, пока PracticeHub не подтвердит, в каком поле v3 хранится номер пациента (MRN). До тех пор пациенты синхронизируются через прежнее подключение, и все существующие MRN сохраняются.",
    "patientsCheckFirst": "Перед включением пациентов выполняется живая проверка 20 пациентов: у каждого в v3 должен быть номер пациента (MRN), совпадающий с номером в прежнем подключении.",
    "waitingForMigration": "Ожидание миграции PracticeHub: у {{populated}} из {{checked}} проверенных пациентов есть номер пациента в v3, и {{equal}} совпадают с номером в прежнем подключении. Переключатель пациентов остаётся выключенным, все существующие MRN сохраняются.",
    "mrnCheckFailed": "Проверка номеров пациентов не смогла связаться с PracticeHub, поэтому переключатель пациентов остаётся выключенным. Повторите попытку через несколько минут.",
    "saveFailed": "Не удалось сохранить настройки PracticeHub v3.",
    "switchesTitle": "Чтение из v3 по ресурсам",
    "switchesHint": "Всё выключено до октябрьской проверки. Выключенный ресурс читается из старого API, как сейчас.",
    "resource": {
      "patients": "Пациенты",
      "appointments": "Записи на приём",
      "practitioners": "Специалисты",
      "files": "Файлы",
      "clinical_notes": "Клинические заметки"
    },
    "saveSwitches": "Сохранить переключатели",
    "switchesSaved": "Переключатели сохранены.",
    "pushesLabel": "Отправлять отчёты в PracticeHub через v3",
    "pushesHint": "Выкл.: отчёты идут через прежнее подключение, как сейчас. Вкл.: заметка и PDF идут через v3 с ключом записи, каждый с нашей ссылкой, чтобы потерянный ответ находился снова, а не отправлялся дважды.",
    "pushesOn": "Отчёты теперь отправляются в PracticeHub через v3.",
    "pushesOff": "Отчёты теперь отправляются в PracticeHub через прежнее подключение.",
    "pushesNeedWriteKey": "Сначала сохраните ключ записи v3."
  },
  "quickReportDetour": {
    "question": "Добавить скрининг осанки или визуализацию перед продолжением?",
    "hint": "Сейчас можно добавить отчёт PostureScreen или снимки; затем вы вернётесь к диагнозу.",
    "addPosture": "Добавить скрининг осанки",
    "addImaging": "Добавить снимки",
    "no": "Нет, продолжить",
    "bannerText": "Когда добавите всё нужное, продолжите к диагнозу.",
    "returnButton": "Перейти к диагнозу"
  },
  "phFiles": {
    "title_one": "{{count}} файл в PracticeHub",
    "title_few": "{{count}} файла в PracticeHub",
    "title_many": "{{count}} файлов в PracticeHub",
    "title_other": "{{count}} файла в PracticeHub",
    "none": "В PracticeHub нет файлов этого пациента.",
    "unnamed": "(без имени файла)",
    "listOnly": "Список из PracticeHub; открывайте файлы в PracticeHub.",
    "rateLimited": "Файлы PracticeHub временно недоступны. Они скоро снова появятся."
  },
  "imagingStudy": {
    "title": "Исследование визуализации",
    "imagesCount_one": "{{count}} снимок",
    "imagesCount_few": "{{count}} снимка",
    "imagesCount_many": "{{count}} снимков",
    "imagesCount_other": "{{count}} снимка",
    "status_uploaded": "Ещё не прочитано",
    "status_analysed": "Сводка ждёт проверки",
    "status_accepted": "Сводка принята",
    "analyse": "Прочитать все снимки вместе ({{count}})",
    "analysing": "Чтение исследования…",
    "accept": "Принять сводку",
    "reviewLines": "Проверить строки",
    "hideLines": "Скрыть проверку строк",
    "edit": "Изменить",
    "save": "Сохранить",
    "cancel": "Отмена",
    "reject": "Отклонить",
    "rejected": "отклонено",
    "edited": "изменено",
    "series": "Серии",
    "findings": "Находки",
    "measurements": "Измерения",
    "impressions": "Заключения",
    "pendingNote": "Наблюдение с помощью ИИ. Ничего отсюда не попадает в диагноз или отчёт, пока вы не примете сводку.",
    "acceptedNote": "Наблюдение с помощью ИИ, сводка принята клиницистом. Принятые и изменённые строки учитываются в диагнозе и в разделе исследований отчёта.",
    "excluded_one": "{{count}} файл не удалось прочитать ИИ (анализируются только изображения JPEG, PNG или WebP).",
    "excluded_few": "{{count}} файла не удалось прочитать ИИ (анализируются только изображения JPEG, PNG или WebP).",
    "excluded_many": "{{count}} файлов не удалось прочитать ИИ (анализируются только изображения JPEG, PNG или WebP).",
    "excluded_other": "{{count}} файла не удалось прочитать ИИ (анализируются только изображения JPEG, PNG или WebP).",
    "groupUnassigned": "Прочитать предыдущие снимки вместе как одно исследование ({{count}})",
    "regionMatch": "Область снимков совпадает с областью жалобы.",
    "regionMismatch": "На снимках {{imaging}}, но область жалобы: {{complaint}}. Перед принятием проверьте, что снимки относятся к этой жалобе.",
    "regionUnknown": "Область снимков не удалось определить; сверьте её с областью жалобы самостоятельно.",
    "regionNoComplaint": "В этой оценке нет области жалобы для сравнения со снимками.",
    "failed": "Не удалось: {{message}}",
    "region": {
      "cervical": "шейный отдел",
      "thoracic": "грудной отдел",
      "lumbar": "поясничный отдел",
      "sacral": "крестец/таз",
      "shoulder": "плечо",
      "elbow": "локоть",
      "wrist_hand": "запястье/кисть",
      "hip": "тазобедренный сустав",
      "knee": "колено",
      "ankle_foot": "голеностоп/стопа",
      "tmj": "челюсть (ВНЧС)"
    },
    "reportAttached": "+ заключение рентгенолога",
    "radiologistReport": "Заключение рентгенолога (дословно)",
    "radFindings": "Описание рентгенолога",
    "radImpression": "Заключение рентгенолога",
    "aiObservations": "Наблюдения ИИ по снимкам",
    "disagreeBanner": "Наблюдения ИИ расходятся с заключением рентгенолога:",
    "radSays": "рентгенолог",
    "aiSays": "ИИ",
    "agreeNote": "Наблюдения ИИ совпадают с заключением рентгенолога.",
    "compareUnavailable": "Не удалось сравнить заключение рентгенолога с наблюдениями ИИ: {{note}}",
    "aiUnavailable": "Наблюдения ИИ по снимкам недоступны ({{note}}). Заключение рентгенолога приводится отдельно.",
    "reportUnrecognised": "Вместе со снимками загружен PDF, но в нём не найдены разделы «Описание» или «Заключение». Прочитайте сам документ."
  },
  "postureCapture": {
    "title": "Съёмка осанки",
    "steps": "Шаги съёмки осанки",
    "step": {
      "setup": "Сеанс",
      "photos": "Фотографии",
      "wall": "Замеры у стены",
      "mark": "Отметьте точки",
      "summary": "Сводка"
    },
    "script": "Встаньте так, как стоите обычно. Не выпрямляйтесь для камеры. Смотрите прямо перед собой.",
    "kind": {
      "label": "Тип сеанса",
      "normal": "Обычный",
      "stand_tall": "Выпрямленная стойка",
      "repeat_test": "Повторная проверка"
    },
    "week": {
      "label": "Неделя",
      "none": "Без недели",
      "w0": "Неделя 0",
      "w6": "Неделя 6",
      "w12": "Неделя 12"
    },
    "settings": {
      "cameraDistanceCm": "Расстояние до камеры (см)",
      "lensHeightCm": "Высота объектива (см)",
      "floorMark": "Отметка на полу использована",
      "defaultsHint": "Значения по умолчанию соответствуют стандартной установке клиники. Меняйте их только если камера сегодня стояла иначе."
    },
    "createSession": "Создать сеанс",
    "creating": "Создание сеанса...",
    "sessionCreated": "Сеанс создан",
    "view": {
      "front": "Спереди",
      "back": "Сзади",
      "left": "Левая сторона",
      "right": "Правая сторона"
    },
    "photos": {
      "hint": "До {{max}} фотографий на каждый ракурс, JPEG или PNG. Каждая фотография загружается сразу после выбора.",
      "takePhoto": "Сделать фото",
      "chooseFile": "Выбрать файл",
      "limit": "Для этого ракурса уже есть {{max}} фотографии.",
      "uploading": "Загрузка...",
      "uploaded": "Загружено",
      "failed": "Загрузка отклонена",
      "refusedType": "Принимаются только фотографии JPEG или PNG.",
      "refusedSize": "Фотография больше 15 МБ.",
      "empty": "Фото пока нет",
      "thumbAlt": "Фото {{view}} {{index}}"
    },
    "wall": {
      "title": "Замеры голова-стена",
      "hint": "Три замера в сантиметрах, человек стоит спиной к стене.",
      "reading": "Замер {{n}} (см)",
      "save": "Сохранить замеры",
      "saved": "Замеры сохранены",
      "invalid": "Введите три числа от нуля сантиметров и выше."
    },
    "mark": {
      "next": "Отметьте",
      "complete": "Все точки поставлены",
      "undo": "Отменить последнюю точку",
      "redo": "Заново для этого ракурса",
      "save": "Сохранить точки",
      "saved": "Точки сохранены",
      "earlierHidden": "Цифры предыдущих сеансов не показываются во время разметки.",
      "noCaptures": "Фотографий пока нет. Сначала добавьте фотографии.",
      "loadingImage": "Загрузка фотографии...",
      "imageAlt": "Фото {{view}} {{index}}, нажмите, чтобы поставить точку"
    },
    "landmark": {
      "tragus": "Точка уха (козелок)",
      "c7": "Основание шеи (C7)",
      "leftEar": "Левое ухо",
      "rightEar": "Правое ухо",
      "leftShoulder": "Левое плечо",
      "rightShoulder": "Правое плечо"
    },
    "summary": {
      "title": "Сводка съёмки",
      "noVerdict": "Только углы и проверка съёмки. На этом экране нет баллов, результата и отчёта.",
      "noneMarked": "Для этого ракурса точки не сохранены.",
      "neckAngle": "Угол шеи",
      "shoulderLine": "Наклон линии плеч",
      "headLine": "Наклон линии головы",
      "mean": "Среднее",
      "spread": "разброс",
      "needsRemark": "Нужна повторная разметка: фотографии расходятся",
      "agree": "Фотографии согласуются",
      "settings": "Проверка установки съёмки",
      "settingsOk": "Установка в пределах стандартных допусков.",
      "nominal": "стандарт",
      "remark": "Разметить точки заново"
    },
    "next": "Далее",
    "error": {
      "generic": "Сервер отклонил запрос."
    }
  }
}
